<template>
  <div class="content" :class="pointerIFg ? 'ButtonEvents' : ''">
    <!-- vant 时间选择器 -->


    <!-- <van-calendar ref="vanCalendar" v-model="show" :show-confirm="false" @confirm="onConfirm" color="#bb9975"
            :min-date="minDate" :max-date="maxDate" /> -->
    <van-calendar ref="vanCalendar" v-if="erIfg == 0" v-model="show" @confirm="TrueSet" :min-date="minDate"
                  :max-date="maxDate" color="#C2986E"/>
    <van-calendar v-if="erIfg == 3" v-model="show" type="range" @confirm="TrueSet1" :min-date="minDate"
                  :max-date="maxDate" color="#C2986E"/>
    <!-- <van-popup v-model="show1" position="bottom" :style="{ height: '50%' }"> -->
    <!-- 选择 -->
    <!-- <van-datetime-picker v-model="date1" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
                :formatter="formatter" @confirm="TrueSet(0)" @cancel="TrueSet(1)"  /> -->

    <!-- <van-datetime-picker v-if="erIfg == 2" v-model="date1" type="year-month" title="选择年月" :min-date="minDate"
                :max-date="maxDate" :formatter="formatter" @confirm="TrueSet(0)" @cancel="TrueSet(1)" /> -->
    <!-- <changWeely v-if="erIfg == 1" :defaults="date1" @onConfirm="Confirm" @onCancel="quxiao" />
            <van-datetime-picker v-if="erIfg == 3 && ifgTime == true" v-model="date1" type="date" title="选择开始时间"
                :min-date="minDate" :formatter="formatter" :max-date="maxDate" @confirm="TrueSet(0)"
                @cancel="quxiao(0)" /> -->
    <!-- <van-datetime-picker v-if="erIfg == 3 && ifgTime == false" v-model="date1" type="date" title="选择结束时间"
                :min-date="minDate" :formatter="formatter" :max-date="maxDate" @confirm="TrueSet(0, 1)"
                @cancel="quxiao(1)" /> -->
    <!-- </van-popup> -->
    <div style="position: sticky;top: 0;z-index:1000;background-color: #ffffff;">
      <!-- 门店下拉框 -->
      <div class="title_xia">
        <!-- <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" @change="SetDropdown" />
            </van-dropdown-menu> -->
        <el-select v-model="value1" @change="SetDropdown" style="width: max-content;">
          <el-option v-for="item in option1" :key="item.text" :label="item.text" :value="item.text">
          </el-option>
        </el-select>
      </div>
      <!-- 日期选择器 -->
      <div class="day_xue">
        <div class="day_xue_da">
          <div :class="erIfg == 0 ? 'xueze' : ''" @click="SetErIfg(0)">日</div>
          <div :class="erIfg == 1 ? 'xueze' : ''" @click="SetErIfg(1)">周</div>
          <div :class="erIfg == 2 ? 'xueze' : ''" @click="SetErIfg(2)">月</div>
          <div :class="erIfg == 3 ? 'xueze' : ''" @click="SetErIfg(3)">自定义</div>
        </div>
      </div>
      <!-- 时间选择器 -->
      <div class="title_nav" style="padding: 12px 0;">
        <!-- 日选择器 -->
        <div class="nav">
          <div>
                        <span class="nav_img" v-if="erIfg !== 3">
                            <img src="../../assets/Group 493.png"> </span><span class="nav_text " v-if="erIfg == 0"
                                                                                @click="nextTa(0)"
                                                                                style="margin-left: 10px;">前一天</span>
            <span class="nav_text " v-if="erIfg == 1" @click="nextTa(0)"
                  style="margin-left: 10px;">前一周</span>
            <span class="nav_text " v-if="erIfg == 2" @click="nextTa(0)"
                  style="margin-left: 10px;">前一月</span>
          </div>
          <div class="onep">
            <!-- <div @click="SetShow()" v-if="erIfg != 1">{{ date }}</div> -->
            <!-- <div v-if="erIfg == 3" style="width:16px;height:16px"><img style="width:100%;height:100%"
                                src="../../assets/img/日历 (1).png"></div> -->
            <!-- <van-cell is-link @click="showPopup"
                            style="font-size:12px;background-color:#EEEEEE;border-radius: 12px;height: 24px;">{{ date
                            }}</van-cell> -->
            <div @click="showPopup" v-if="erIfg != 0"
                 style="font-size:12px;background-color:#EEEEEE;border-radius: 4px;">
              <div style="line-height: normal;padding: 4px 8px;display: flex;">
                <div style="display: flex;flex-direction: column;">
                  <div style="color: rgb(102, 102, 102);
font-size: 12px;
font-weight: 400;
line-height: 12px;">{{ dateData[0].y }}
                  </div>
                  <div style="color: rgb(51, 51, 51);
font-size: 12px;
font-weight: 400;margin-top: 4px;">{{ dateData[0].m }}/{{ dateData[0].d }} {{ dateData[0].z }}
                  </div>
                </div>
                <div style="border-color: rgb(204, 204, 204);transform: rotate(90.00deg);width: 28px;border-style: solid;
height: 0;margin: 8px 0px;" class="fengjiexiao"></div>
                <div style="display: flex;flex-direction: column;">
                  <div style="color: rgb(102, 102, 102);
font-size: 12px;
font-weight: 400;
line-height: 12px;">{{ dateData[1].y }}
                  </div>
                  <div style="color: rgb(51, 51, 51);
font-size: 12px;
font-weight: 400;margin-top: 4px;">{{ dateData[1].m }}/{{ dateData[1].d }} {{ dateData[1].z }}
                  </div>
                </div>
              </div>
            </div>
            <div @click="showPopup" v-else
                 style="font-size:12px;background-color:#EEEEEE;border-radius: 4px;height: 24px;">
              <div style="line-height: normal;padding: 4px 8px;display: flex;">
                {{ dateData[0].y }}/{{ dateData[0].m }}/{{ dateData[0].d }} {{ dateData[0].z }}
              </div>
            </div>
          </div>
          <div>
                        <span class="nav_text " v-if="erIfg == 0" @click="nextTa(1)"
                              style="margin-right: 10px;">后一天</span>
            <span class="nav_text " v-if="erIfg == 1" @click="nextTa(1)"
                  style="margin-right: 10px;">后一周</span>
            <span class="nav_text " v-if="erIfg == 2" @click="nextTa(1)"
                  style="margin-right: 10px;">后一月</span>
            <span class="nav_img" v-if="erIfg !== 3"><img src="../../assets/Group 493 (1).png"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- logo -->
    <!-- <div class="fiexd">
            <div class="logo">
                <img src="../../assets/logo.png" alt="">
            </div> -->
    <!-- </div> -->
    <!-- 内容区 -->

    <div class="tent">
      <!-- 轮播图 -->
      <div class="lbimg">
        <div class="swiper-container" id="swiper">
          <div class="swiper-wrapper">
            <!-- v-if="!ifgs && !notIfg" -->
            <div class="lbimg_content swiper-slide" v-if="!notIfg">
              <div class="content_tow">
                <div class="tow_title">
                  <div class="title_chu">
                    <img src="../../assets/img/实时数据.png">
                  </div>
                  <div class="title_top">
                    <div>实时数据</div>
                  </div>
                </div>
                <div class="tow_content" style="padding: 0px;">
                  <div class="tow_content_one">
                    <div
                        style="display: flex;flex-direction: column;font-size: 14px;padding: 12px;padding-bottom: 0;">
                      <div
                          style="color: #666666;display: flex;justify-content: center;flex-direction: column;align-self: center;">
                        <div style="text-align: center;color: rgb(102, 102, 102);
font-size: 16px;
font-weight: 400;">营业净额
                        </div>
                        <div style="margin-top: 8px;font-size: 18px;color: #333333;
                                                color: rgb(51, 51, 51);
font-size: 18px;
font-weight: 500;
line-height: 18px;">
                          {{ dataValue.RealTimeResultList[0].payamount }}元
                        </div>
                      </div>
                      <div
                          style="margin-top: 12px;display: flex;align-items: center;justify-content: center;">
                        <div style="color: #666666;min-width: 163px;text-align: center;
                                                color: rgb(102, 102, 102);
font-size: 16px;
font-weight: 400;
letter-spacing: 0px;
                                                ">
                          未结金额
                          <div style="margin-top: 8px;font-size: 18px;color: #E30F0F;
                                                    color: rgb(227, 15, 15);
font-size: 18px;
font-weight: 500;
line-height: 18px;
                                                    ">
                            {{ dataValue.RealTimeResultList[0].nopayamount }}元
                          </div>
                        </div>

                        <div class="fengjiexiao " style="border-color:rgb(221, 221, 221);position: absolute;
width: 36px;
height: 0;
transform: rotate(90.00deg);margin: 0px;">
                        </div>


                        <div style="color: #666666;min-width: 163px;text-align: center;
font-size: 16px;
font-weight: 400;
letter-spacing: 0px;
                                                ">
                          已结金额
                          <div style="margin-top: 8px;font-size: 18px;color: #333333;
                                                   color: rgb(51, 51, 51);
font-size: 18px;
font-weight: 500;
line-height: 18px;
                                                    ">
                            {{ dataValue.RealTimeResultList[0].settleamount }}元
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction: column;padding: 16px 12px; padding-bottom: 0px;"
                         v-if="erIfg == 0">
                      <div style="display: flex;justify-content: space-between;">
                        <div style="background-color: #FCF7EF;width: 50%;display: flex
                                                ;border-radius: 5px;
                                            flex-direction: column;align-items: center;">
                          <div style="display: flex;justify-content: center;align-items: center;
                                                    flex-direction: column;padding-top: 16px;">
                            <div class="font-smaii ">昨日收入</div>
                            <div class="font-num">
                              {{ zhoushang[0].yesterdayamount }}元
                            </div>
                          </div>
                          <div class="fengjiexiao "
                               style="width: 85%;border-color:#DDDDDD;margin:12px;">
                          </div>
                          <div style="font-size: 12px;padding-bottom: 16px;">
                            <div style="text-align: center;" class="font-14">环比昨日</div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: green;" v-if="zhoushang[0].QOQyesterdayflag == 1">

                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2338.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].QOQyesterdayamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].QOQyesterdayratio }}
                              </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: red;" v-else>
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2339.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].QOQyesterdayamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].QOQyesterdayratio }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="background-color: #FCF7EF;border-radius: 5px;width: 50%;display: flex;margin-left: 9px;
                                            flex-direction: column;align-items: center;">
                          <div style="display: flex;justify-content: center;align-items: center;
                                                    flex-direction: column;padding-top: 16px;">
                            <div class="font-smaii ">上周本日</div>
                            <div class="font-num">
                              {{ zhoushang[0].lastweektodayamount }}元
                            </div>
                          </div>
                          <div class="fengjiexiao "
                               style="width: 85%;border-color:#DDDDDD;margin:12px;">
                          </div>
                          <div style="font-size: 12px;padding-bottom: 16px;">
                            <div style="text-align: center;" class="font-14">同比上周本日</div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                        color: red;
                                                    " v-if="zhoushang[0].YOYlastweektodayflag == 0">
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2339.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweektodayamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweektodayratio }}
                              </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                        color: green;
                                                    " v-else>
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2338.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweektodayamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweektodayratio }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: space-between;">
                        <div style="background-color: #FCF7EF;width: 50%;display: flex; background-color: #FCF7EF;margin-top: 8px;flex-direction: column;
                                            align-items: center;border-radius: 5px;padding-top: 15px;">
                          <div style="display: flex;flex-direction: column;
                                                justify-content: center;align-items: center;">
                            <div class="font-smaii ">
                              本周累计
                            </div>
                            <div class="font-num">
                              {{ zhoushang[0].weekamount }}元
                            </div>
                          </div>
                          <div class="fengjiexiao "
                               style="width: 85%;border-color:#DDDDDD;margin:12px;">
                          </div>
                          <div style="display: flex;flex-direction: column;
                                                justify-content: center;align-items: center;">
                            <div class="font-smaii ">
                              上周累计
                            </div>
                            <div class="font-num">
                              {{ zhoushang[0].lastweekamount }}元
                            </div>
                          </div>
                          <div style="font-size: 12px;margin-top: 8px;padding-bottom: 16px;">
                            <div style="text-align: center;" class="font-14">同比上周</div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: green;   " v-if="zhoushang[0].YOYlastweekflag == 1">
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2338.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweekamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweekratio }}
                              </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: red;   " v-else>
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2339.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweekamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastweekratio }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style=" width: 50%;display: flex;margin-left: 10px; background-color: #FCF7EF;margin-top: 8px;flex-direction: column;
                                           align-items: center;border-radius: 5px;">
                          <div style="display: flex;flex-direction: column;
                                                justify-content: center;align-items: center;padding-top: 16px;">
                            <div class="font-smaii ">
                              本月累计
                            </div>
                            <div style="width: 100%;" class="font-num">
                              {{ zhoushang[0].monthamount }}元
                            </div>
                          </div>
                          <div class="fengjiexiao "
                               style="width: 85%;border-color: #DDDDDD;margin:12px;">
                          </div>
                          <div style="display: flex;flex-direction: column;
                                                justify-content: center;align-items: center;">
                            <div class="font-smaii ">
                              上月累计
                            </div>
                            <div class="font-num">
                              {{ zhoushang[0].lastmonthamount }}元
                            </div>
                          </div>
                          <div style="font-size: 12px;margin-top: 8px;padding-bottom: 16px;">
                            <div style="text-align: center;" class="font-14">同比上月</div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: green;   " v-if="zhoushang[0].YOYlastmonthflag == 1">
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2338.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastmonthamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">{{
                                  zhoushang[0].YOYlastmonthratio
                                }}
                              </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 8px;
                                                    color: red;   " v-else>
                              <div style="width: 12px;height: 12px;"><img
                                  style="width: 100%;height: 100%;"
                                  src="../../assets/img/Group 2339.png"></div>
                              <div style="margin-left: 5px;" class="font-14-p">
                                {{ zhoushang[0].YOYlastmonthamount }}元
                              </div>
                              <div style="margin-left: 5px;" class="font-14-p">{{
                                  zhoushang[0].YOYlastmonthratio
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="EchartsOne[0]!==undefined">
                      <div class="tow_tow" id="main" v-if="EchartsOne[0].length !== 0">
                      </div>
                    </div>

                    <!-- <div class="tow_three" style="margin-bottom: 16px;">
                                            <div class="tow_three_table">
                                                <div class="three_table_content" v-for="(itme, index) in ChannelTbale"
                                                    :key="index">
                                                    <div class="three_table_content_name">
                                                        {{ itme.name }}
                                                    </div>
                                                    <div class="three_table_content_price">
                                                        {{ itme.price }}元
                                                        <div class="three_table_content_ifg">
                                                            <img src="../../assets/img/Group 11931.png"
                                                                v-if="itme.ifg != 1">
                                                            <img src="../../assets/img/Group 2337.png" v-else>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div> -->
                    <!-- <div class="fengjiexiao"></div> -->
                    <!-- <div class="tow_three" style="margin-top: 16px;margin-bottom: 16px;">
                                            <div class="tow_three_title">
                                                上座率
                                            </div>
                                            <div class="tow_three_table">
                                                <div class="three_table_content" v-for="(itme, index) in ServedTbale"
                                                    :key="index">
                                                    <div class="three_table_content_name">
                                                        {{ itme.name }}
                                                    </div>
                                                    <div class="three_table_content_price">
                                                        {{ itme.price }}元
                                                    </div>

                                                </div>
                                            </div>
                                        </div> -->
                    <!-- <div class="fengjiexiao"></div> -->
                    <div class="tow_three" style="padding:0 12px;">
                      <div class="tow_three_table" style="margin: 0;">
                        <div class="three_table_content" v-for="(itme, index) in CateringOne"
                             :key="index" :class="index == 0 ? 'three_maring' : ''">
                          <div class="three_table_content_name">
                            {{ itme.name }}
                          </div>
                          <div class="three_table_content_price">
                            {{ itme.price }}
                          </div>

                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: center;">
                      <div class="fengjiexiao"
                           style="width: 92%;margin-top: 12px;margin-bottom: 12px;">
                      </div>
                    </div>

                    <div class="tow_three" style="padding:0 12px;">
                      <div class="tow_three_table" style="margin: 0;">
                        <div class="three_table_content" v-for="(itme, index) in CateringTow"
                             :key="index" :class="index == 0 ? 'three_maring' : ''">
                          <div class="three_table_content_name">
                            {{ itme.name }}
                          </div>
                          <div class="three_table_content_price"
                               :class="itme.red == 1 ? 'red' : ''">
                            {{ itme.price }} <img v-if="itme.red == 3"
                                                  style="margin-left: 4px;display: none;"
                                                  @click="StoreshowThree = true"
                                                  src="../../assets/img/Group 23941.png">
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 内容第三个区域 -->
              <div class="content_throw">
                <div class="throw_nav">
                  <div class="tow_title">
                    <div class="title_chu">
                      <img src="../../assets/img/销售数据.png">
                    </div>
                    <div class="title_top">
                      <div>销售数据</div>
                    </div>
                  </div>
                  <div class="throw_buttom" @click="GoSelf()">
                    <div>详细销售分析</div>
                    <div class="button_imgs">
                      <img src="../../assets/img/前往.png">
                    </div>

                  </div>
                </div>
                <div class="onsb">
                  <div class="throw_content_title" v-if="dataValue.SoldResultList !== undefined">
                    营业收入（总）：{{ dataValue.SoldResultList[0].operatingincome }}元
                  </div>
                  <div class="throw_content_text">
                    <div class="content_text" v-for="(itme, index) in CateringThree" :key="index"
                         :class="index == 0 ? 'content_max' : ''">
                      <div class="text_title">
                        <div>{{ itme.title }}</div>
                        <div class="title_percent">{{ itme.percent }}</div>
                      </div>
                      <div class="text_textOne">
                        <div>{{ itme.name }}</div>
                        <div class="text_price">{{ itme.price }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 内容第四个区域 -->
              <div class="content_foue">
                <div class="throw_nav">
                  <div class="tow_title">
                    <div class="title_chu">
                      <img src="../../assets/img/客情数据.png">
                    </div>
                    <div class="title_top">
                      <div>客情数据</div>
                    </div>
                  </div>
                  <!-- <div class="throw_buttom">
                                        <div>详细客情分析</div>
                                        <div class="button_imgs">
                                            <img src="../../assets/img/前往.png">
                                        </div>

                                    </div> -->
                </div>
                <div class="tow_content">
                  <div class="tow_content_tent" v-for="(itme, index) in Cateringfoue" :key="index">
                    <div class="tent_title">
                      <div class="title_left">{{ itme.title }}</div>
                      <div class="title_right" style="font-size: 16px;">{{ itme.name }}</div>
                    </div>
                    <div class="fengjiexiao" style="border-color: #DDDDDD;"></div>
                    <div v-if="index == 3" class="gressOne">{{ itme.TongPercent }}</div>
                    <div class="gress" style="margin-top: 0px;color: #666;display: flex;"
                         v-if="index !== 3">同比
                      <div style="display: flex;" v-if="itme.TongIfg == 0"><img
                          src="../../assets/img/Group 2339.png"
                          style="margin-left: 10px;margin-right: 10px;">
                        <div class="red" style="margin-top: 0px;">{{ itme.TongPercent }}</div>
                      </div>
                      <div style="display: flex;" v-if="itme.TongIfg == 1"><img
                          src="../../assets/img/Group 2338.png"
                          style="margin-left: 10px;margin-right: 10px;">
                        <div class="gress" style="margin-top: 0px;">{{ itme.TongPercent }}</div>
                      </div>
                    </div>
                    <div class="red" v-if="index !== 3"
                         style="margin-top: 16px;color: #666;display: flex;">环比
                      <div style="display: flex;" v-if="itme.HuanIfg == 0">
                        <img src="../../assets/img/Group 2339.png"
                             style="margin-left: 10px;margin-right: 10px;">
                        <div class="red" style="margin-top: 0px;">{{ itme.HuanPercent }}</div>
                      </div>
                      <div style="display: flex;" v-if="itme.HuanIfg == 1">
                        <img src="../../assets/img/Group 2338.png"
                             style="margin-left: 10px;margin-right: 10px;">
                        <div class="gress" style="margin-top: 0px;">{{ itme.HuanPercent }}</div>
                      </div>
                    </div>
                    <div v-if="index == 3" class="gresstow">
                      <el-rate v-model="itme.HuanPercent"
                               disabled show-score text-color="#ff9900" score-template="{value}">
                      </el-rate>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 内容第5个区域 -->
              <div class="content_five">
                <div class="throw_nav">
                  <div class="tow_title">
                    <div class="title_chu">
                      <img src="../../assets/img/排行榜.png">
                    </div>
                    <div class="title_top">
                      <div>排行榜</div>
                    </div>
                  </div>
                  <!-- <div class="throw_buttom">
                                        <div>详细排行榜分析</div>
                                        <div class="button_imgs">
                                            <img src="../../assets/img/前往.png">
                                        </div>

                                    </div> -->
                </div>
                <div style="padding-top: 16px;">
                  <div class="fiv_content" v-for="(itme, index) in  Cateringfive" :key="index">
                    <div class="fiv">
                      <div class="contet_fiv_text">

                        <div class="fiv_text_content">
                          <div class="fiv_top">
                            <div
                                style="display: flex;justify-content: center;align-items: center;">
                              <img :src="itme.img" style="width: 16px;height: 16px;">

                              <div style="margin-left: 8px;">{{ itme.productname }}</div>
                            </div>

                            <div class="yess">占比{{ itme.productratio }}</div>
                          </div>
                          <div class="fiv_boumm">
                            <div>销量：{{ itme.productqty }}</div>
                            <div>销售额：{{ itme.productamount }}元</div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="fengjiexiao" style="width: 100%;margin:16px 0;"
                         v-if="index !== Cateringfive.length - 1"></div>
                  </div>
                </div>
                <div class="five_bottom">
                  <div class="bottom_xia">
                    <div style="display: flex;">
                      <div> 菜品销量预警（近30天）</div>
                      <!-- <div style="color: #E30F0F;margin-left: 20px;">{{
        CateringfiveData.WarningList.procount }}
                                            </div> -->
                    </div>
                    <div style="color: #E30F0F;margin-left: 20px;"
                         v-if="CateringfiveData.WarningList !== undefined">{{
                        CateringfiveData.WarningList.procount
                      }}
                    </div>
                    <div style="color: #E30F0F;display: none;" @click="chankai">查看</div>
                  </div>
                </div>
              </div>
              <!-- 内容第6个区域 -->
              <div class="content_six">
                <div class="throw_nav">
                  <div class="tow_title">
                    <div class="title_chu">
                      <img src="../../assets/img/生产数据.png">
                    </div>
                    <div class="title_top">
                      <div>生产数据</div>
                    </div>
                  </div>
                  <div class="throw_buttom" @click="goChef()">
                    <div>详细生产数据分析</div>
                    <div class="button_imgs">
                      <img src="../../assets/img/前往.png">
                    </div>
                  </div>
                </div>
                <div class="six" id="mains" v-show="!shengcaiIfg">
                </div>
                <div
                    style="height: 150px;display: flex;justify-content: center;align-items: center;flex-direction: column;"
                    v-if="shengcaiIfg">
                  <div style="width: 80px;height: 80px;">
                    <img style="width: 100%;height: 100%;" src="../../assets/暂无数据  图标.png">
                  </div>
                  <div style="color: rgb(153, 153, 153);margin-top: 12px;
font-size: 14px;
font-weight: 500;">暂无数据
                  </div>
                </div>
                <div v-else style="padding-bottom: 16px;font-size: 16px;">
                  <div class="six_title">
                    厨师数据展示
                  </div>
                  <div class="fiv_content" v-for="(itme, index) in  CateringSix" :key="index"
                       v-if="index < Ifgnum">
                    <div class="fiv">
                      <div class="contet_fiv_text">
                        <div class="fiv_text_content">
                          <div class="fiv_top">
                            <div style="color: #666666;">{{ itme.name }}</div>
                            <div style="display: flex;">
                              <div class="yess" style="text-align: right;">超时{{
                                  itme.num
                                }}
                              </div>
                              <div class="yess"
                                   style="color: #C2986E;width:80px;text-align: right;">
                                沽清{{
                                  itme.time
                                }}
                              </div>
                            </div>

                          </div>
                          <div class="fiv_boumm">
                            <div style="color: #333;">生产数：{{ itme.SellOut }}</div>
                            <div style="color: #333;">生产金额：{{ itme.price }}元</div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="fengjiexiao" style="width: 100%;margin:16px 0;"
                         v-if="index !== Ifgnum - 1"></div>
                  </div>
                  <div style="display: flex;justify-content: center;margin-top: 20px;"
                       @click='zhangkai' v-if="Ifgnum == 5 && CateringSix.length > 5"><img
                      src="../../assets/Group 2943.png" style="width: 64px;height: 20px;"></div>
                  <div style="display: flex;justify-content: center;margin-top: 20px;"
                       @click="shuifan" v-if="Ifgnum !== 5">
                    <img src="../../assets/Group 2943 (1).png" style="width: 64px;height: 20px;">
                  </div>
                </div>
              </div>
              <!-- 内容第7个区域 -->
              <div class="content_server">
                <div class="throw_nav">
                  <div class="tow_title">
                    <div class="title_chu">
                      <img src="../../assets/img/活动分析.png">
                    </div>
                    <div class="title_top">
                      <div>活动分析</div>
                    </div>
                  </div>
                  <!-- <div class="throw_buttom" >
                                        <div>详细销售分析</div>
                                        <div class="button_imgs">
                                            <img src="../../assets/img/前往.png">
                                        </div>

                                    </div> -->
                </div>
                <div class="server">
                  <div class="server_title" v-if="CateringServerData[0] !== undefined">
                    总收入：{{ CateringServerData[0].amount }}元
                  </div>
                  <div class="server_one">
                    <div class="one_content" v-for="(itme, index) in CateringServer" :key="index">
                      <div class="one_title">
                        <div>
                          {{ itme.name }}
                        </div>
                        <div class="title_num">
                          {{ itme.num }} <img @click="showIfgTow(index)" style="display:none"
                                              src="../../assets/img/Group 2394.png" alt="">
                        </div>
                      </div>
                      <div class="one_price">
                        {{ itme.price }}元
                      </div>
                    </div>
                  </div>
                  <div class="dasiu">
                    <div class="fiv_content" v-for="(itme, index) in  CateringEight" :key="index">
                      <div class="fiv">
                        <div class="contet_fiv_text">
                          <div class="fiv_text_content">
                            <div class="fiv_top">
                              <div>{{ itme.name }}</div>
                              <div class="yess">占比{{ itme.zhanbei }}</div>
                            </div>
                            <div class="fiv_boumm">
                              <div>销量：{{ itme.num }}</div>
                              <div>销售额：{{ itme.money }}元</div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="fengjiexiao" style="width: 100%;margin:16px 0;"
                           v-if="index !== 2"></div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!-- <chefHome v-if="!notIfg"></chefHome> -->
            <not :width="widths" v-if="notIfg"/>
            <!-- <sale /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="opne">
      <van-popup v-model="Storeshow" closeable @click-close-icon="showIfg" @click-overlay="showIfg">
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
             v-if="showIndex == 0">
          <div style="text-align: center;font-size: 16px;color: #333;">超时详情</div>
          <div style="margin-top: 10px;" class="fxid"></div>
          <div style="padding: 10px;min-height: 100px; max-height: 250px; overflow: scroll;">
            <div style="font-size: 14px;" v-for="itme in 2">

              <div style="display: flex;justify-content: space-between;">
                <div>祖传粉蒸肉</div>
                <div>桌台：A009</div>
              </div>
              <div style="font-size: 12px;color: #666666;">
                <div style="margin-top: 6px;">超时时间：46分钟</div>
                <div style="margin-top: 6px;">起菜时间：2024-03-06 12:56:09</div>
              </div>
              <div style="margin:12px 0px;" class="fxid" v-if="itme !== 2"></div>
            </div>


          </div>
          <div style="margin:12px 0px;" class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
             v-else-if="showIndex == 1">
          <div style="text-align: center;font-size: 16px;color: #333;">沽清详情</div>
          <div style="border: 1px solid #EEEEEE;margin-top: 10px;" class="fxid"></div>
          <div style="padding: 10px;min-height: 100px; max-height: 250px; overflow: scroll;">
            <div style="font-size: 14px;" v-for="itme in 2">

              <div style="display: flex;justify-content: space-between;">
                <div>祖传粉蒸肉</div>
                <div style="display: flex;font-size: 12px;">
                  <div>限购：100</div>
                  <div style="margin-left: 10px;">销售：100</div>
                </div>
              </div>
              <div style="font-size: 12px;color: #666666;">
                <div style="margin-top: 6px;">限购时间：2024-03-06 12:56:09</div>
                <div style="margin-top: 6px;">沽清时间：2024-03-06 12:02:56</div>
              </div>
              <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid" v-if="itme !== 2">
              </div>
            </div>


          </div>
          <div style="border: 1px solid #EEEEEE;margin:12px 0px; " class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
             v-else-if="showIndex == 2">
          <div style="text-align: center;font-size: 16px;color: #333;">退菜详情</div>
          <div style="border: 1px solid #EEEEEE;margin-top: 10px;" class="fxid"></div>
          <div style="padding: 10px;min-height: 100px; max-height: 250px; overflow: scroll;">
            <div style="font-size: 14px;" v-for="itme in 5">

              <div style="display: flex;justify-content: space-between;">
                <div>祖传粉蒸肉</div>
                <div>桌台：A009</div>
              </div>
              <div style="font-size: 12px;color: #666666;">
                <div style="margin-top: 6px;">退菜时间：2024-03-06 12:56:09</div>
                <div style="margin-top: 6px;">退菜金额：￥40</div>
                <div style="margin-top: 6px;">退菜原因：上菜速度慢</div>
              </div>
              <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid" v-if="itme !== 2">
              </div>
            </div>


          </div>
          <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
            </div>
          </div>
        </div>


      </van-popup>
    </div>
    <div class="opne">
      <van-popup v-model="StoreshowOne" closeable @click-close-icon="showIfgOne" @click-overlay="showIfgOne">
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;">
          <div style="text-align: center;font-size: 16px;color: #333;">菜品销量预警（近30天）</div>
          <div style="margin-top: 10px;" class="fxid"></div>
          <div class="table">
            <table class="tables" width="100%">
              <tr class="table_one">
                <td style="color: #6F6F6F;">名称</td>
                <td style="color: #6F6F6F;">销量</td>
              </tr>
              <tr v-for="(itme, index) in tableData" :key="index">
                <td class="one">{{ itme.name }}</td>
                <td class="tow">{{ itme.address }}</td>
              </tr>
            </table>
          </div>
          <div style="margin:12px 0px;" class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfgOne">关闭</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="opne">
      <van-popup v-model="StoreshowTow" closeable @click-close-icon="showIfgTows" @click-overlay="showIfgTows">
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;">
          <div style="text-align: center;font-size: 16px;color: #333;" v-if="StoreshowIfg == 0">团购套餐</div>
          <div style="text-align: center;font-size: 16px;color: #333;" v-else>代金券</div>
          <div style="margin-top: 10px;" class="fxid"></div>
          <div class="table">
            <table class="tables" width="100%">
              <tr class="table_one">
                <td style="color: #6F6F6F;">类型</td>
                <td style="color: #6F6F6F;">名称</td>
                <td style="color: #6F6F6F;">数量</td>
                <td style="color: #6F6F6F;">金额</td>
              </tr>
              <tr v-for="(itme, index) in tableDatas" :key="index">
                <td class="one">{{ itme.lx }}</td>
                <td class="one">{{ itme.name }}</td>
                <td class="one">{{ itme.num }}</td>
                <td class="tow">￥{{ itme.address }}</td>

              </tr>
            </table>
          </div>
          <div style="margin:12px 0px;" class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfgTows">关闭</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="opne">
      <van-popup v-model="StoreshowThree" closeable @click-close-icon="showIfgThree"
                 @click-overlay="showIfgThree">
        <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;">
          <div style="text-align: center;font-size: 16px;color: #333;">已沽清菜品明细</div>
          <div style="margin-top: 10px;" class="fxid"></div>
          <div class="table">
            <table class="tables" width="100%">
              <tr class="table_one">
                <td style="color: #6F6F6F;">名称</td>
                <td style="color: #6F6F6F;">沽清时间</td>
                <td style="color: #6F6F6F;">销量</td>
              </tr>
              <tr v-for="(itme, index) in tableDataThree" :key="index">
                <td class="one">{{ itme.name }}</td>
                <td class="one">{{ itme.num }}</td>
                <td class="tow">￥{{ itme.address }}</td>
              </tr>
            </table>
          </div>
          <div style="margin:12px 0px;" class="fxid"></div>
          <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
            <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
              <div style="font-size: 16px;color: #ffffff;" @click="showIfgThree">关闭</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 弹窗 -->
    <top v-if="PageIfg" style="z-index: 100000000;"></top>
    <!-- 等待 -->
    <loading style="z-index: 10000000;" v-if="loadingIFg"></loading>

  </div>
</template>

<script>
import top from '../../components/top/index.vue'
import loading from '../../components/loading/index.vue'
import 'swiper/css/swiper.css'
import {unZip} from '../../utils/ZIP/index.js';
import {Toast} from 'vant';
import Week from '@/components/Week/index.vue';
import variety from '@/components/variety/index.vue';
import sale from '@/views/sale/index.vue';
import moment from "moment";
import "moment/locale/zh-cn";
import chefHome from '@/views/chefHome/index.vue';
import not from '@/components/not/index.vue';
import index from '../HomeOne/index.vue';

moment.locale("zh-cn");
const echarts = require('echarts/lib/echarts');
require('echarts/lib/component/title');
require('echarts/lib/chart/pie');
require('echarts/lib/component/toolbox');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/grid');
require('echarts/lib/component/legend');
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
export default {
  data() {
    return {
      widths: 120,
      notIfg: false,
      StoreshowTow: false,
      StoreshowIfg: 0,
      StoreshowThree: false,
      tableData: [
        {
          name: '猪蹄汤',
          address: 95
        },
        {
          name: '爆炒猪肝',
          address: 95
        },
        {
          name: '酸辣鸡杂',
          address: 95
        },
        {
          name: '酸包菜炒粉皮',
          address: 95
        },
        {
          name: '肉沫粉丝煲',
          address: 95
        },

      ],
      tableDataOne: [
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '99元套餐',
          num: 1,
          address: 95
        },
        {
          lx: '合计',
          name: '',
          num: 1,
          address: 95
        },

      ],
      tableDataTow: [
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '美团/大众',
          name: '89代100',
          num: 1,
          address: 95
        },
        {
          lx: '合计',
          name: '',
          num: 1,
          address: 95
        },

      ],
      tableDatas: [],
      tableDataThree: [
        {

          name: '酸包菜炒粉皮',
          num: '01-02 12:23',
          address: 34
        },
        {

          name: '酸包菜炒粉皮',
          num: '01-02 12:23',
          address: 34
        },
        {

          name: '酸包菜炒粉皮',
          num: '01-02 12:23',
          address: 34
        },
      ],
      StoreshowOne: false,
      value1: '',
      option1: [],
      dataValue: {
        RealTimeResultList: [
          {
            payamount: 0,
            operatingincome: 0,
          }
        ]
      },
      date: "2023/12/22",
      lodDate: "2023-12-22",
      SwiperIndex: 0,
      indexYe: 0,
      swiper: null,
      title: "汤富贵城东店",
      oft: 0,
      stickyHeader: null,
      classIfg: true,
      minDate: new Date(2021, 10, 1),
      maxDate: new Date(2024, 11, 31),
      loadingIFg: true,
      pointerIFg: true,
      reportData: [],
      // 报表次数
      reportNum: 0,
      Ifgnum: 5,
      // 汉字数字
      ChineaNum: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
      //汉字周
      ChineaNums: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      //真实数据
      realData: {},
      //开班
      createtime: null,
      //结班
      begintime: null,
      settleworkinfor: [],
      //实收金额
      paidmoney: 0,
      reductionmoney: 0,
      //优惠金额
      PeferentialMoney: 0,
      MtGetMel: {},
      DyGetMel: {},
      //美团总数量
      MtNum: {
        num: 0,
        price: 0,
      },
      dyNum: {
        num: 0,
        price: 0,
      },
      jintiao: {},
      customerEntity: 0,
      Stores: [],
      StoresId: "",
      zhoushang: [
        {
          yesterdayamount: 0,
          YOYlastmonthamount: 0
        }
      ],
      erIfg: 0,
      LeiMoney: [],
      newLeiMoney: [],
      zhankai: false,
      // ChannelTbale: [
      //     { name: "美团", price: "8597.30", ifg: 0 },
      //     { name: "抖音", price: "8597.30", ifg: 1 },
      //     { name: "小程序", price: "8597.30", ifg: 0 }
      // ],
      // ServedTbale: [
      //     { name: "午餐", price: "90%", },
      //     { name: "晚餐", price: "109%", },
      // ],
      CateringOne: [
        {name: "平均上菜时间(每桌)", price: "0分钟",},
        {name: "开台数", price: "0个",},
        {name: "就餐人数", price: "0人",}
      ],
      CateringTow: [
        // { name: "未结帐金额", price: "9864.55元", red: 1 },
        {name: "已点菜品数量", price: "0个", red: 0},
        // { name: "制作中", price: "23个", red: 1 },
        {name: "已沽清菜品", price: "0", red: 3}
      ],
      CateringThree: [
        {title: '堂食', percent: '0%', name: "到店人数", price: '0人'},
        {title: '自提', percent: '0%', name: "人均消费", price: '0元'},
        {title: '外卖', percent: '0%', name: "已退款金额", price: '0元'}
      ],
      Cateringfoue: [
        // { title: '客单量', TongPercent: '0.1%', name: "46个", HuanPercent: '0.2%', ifg: 0 },
        {title: '开台率', TongPercent: '0%', name: "0%", HuanPercent: '0%', ifg: 0, TongIfg: 0, HuanIfg: 1},
        {title: '上座率', TongPercent: '0%', name: "0个", HuanPercent: '0%', ifg: 0, TongIfg: 1, HuanIfg: 1},
        // { title: '投诉', TongPercent: '综合客户满意度', name: "2", HuanPercent: 4, ifg: 1 }
      ],
      Cateringfive: [
        // { img: require("../../assets/img/0.png"), title: '辣椒炒肉', percent: '32%', num: 971, price: "47579.00" },
        // { img: require("../../assets/img/1.png"), title: '祖传蒸肉—大份', percent: '28%', num: 865, price: "47579.00" },
        // { img: require("../../assets/img/2.png"), title: '压锅碎鱼头', percent: '27%', num: 812, price: "47579.00" }
      ],
      CateringfiveData: {},
      CateringSix: [],
      CateringSixOne: [],
      CateringServer: [
        {name: "团购套餐", num: 0, price: "0"},
        {name: "代金券", num: 0, price: "0"}
      ],
      CateringEight: [
        {name: "抖音", zhanbei: "0%", num: 0, money: "0"},
        {name: "美团/大众", zhanbei: "0%", num: 0, money: "0"},
        {name: "小程序 ", zhanbei: "0%", num: 0, money: "0"},
      ],
      monday: '',
      sunday: '',
      show: false,
      date1: new Date(),
      ifgTime: true,
      DateArr: [],
      ifgs: false,
      EchartsData: {
        data: [],
        date: []
      },
      PagesIfg: false,
      EchartsOne: [
        []
      ],
      dateArr: [],
      seltype: 0,
      chefName: [],
      chefNum: [],
      chefMoney: [],
      MoneyMax: 0,
      NumMax: 0,
      CateringServerData: [],
      PageedIfg: false,
      userid: null,
      agentid: '',
      storeid: '',
      indexs: 0,
      navIfgs: 0,
      dateData: [
        {
          y: "2024",
          m: "03",
          d: "01",
          z: "周一"
        },
        {
          y: "2024",
          m: "03",
          d: "02",
          z: "周二"
        },

      ],
      shengcaiIfg: false
      // Zmoney:{
      //     payamount:0,
      //     nopayamount:0,
      //     settleamount:0
      // }
    };
  },
  components: {
    top,
    loading,
    changWeely: Week,
    chefHome,
    variety,
    not,
    sale
  },
  methods: {
    showIfgOne() {
      this.StoreshowOne = false
    },
    GoSelf() {
      sessionStorage.setItem('time', JSON.stringify(this.dateArr))
      sessionStorage.setItem('erifg', JSON.stringify(this.erIfg))
      sessionStorage.setItem('StoresId', JSON.stringify(this.StoresId))
      this.$router.push({path: '/sale', query: {DateArr: this.dateArr, StoresId: this.StoresId, seltype: this.erIfg}})
    },
    showIfgTow(e) {

      this.StoreshowIfg = e
      this.StoreshowTow = !this.StoreshowTow
      if (e == 0) {
        this.tableDatas = this.tableDataOne
      } else if (e == 1) {
        this.tableDatas = this.tableDataTow
      }
    },
    showIfgThree() {
      this.StoreshowThree = false
    },
    showIfgTows() {
      this.StoreshowTow = false
    },
    goChef() {
      sessionStorage.setItem('time', JSON.stringify(this.dateArr))
      sessionStorage.setItem('erifg', JSON.stringify(this.erIfg))
      sessionStorage.setItem('StoresId', JSON.stringify(this.StoresId))
      this.$router.push({
        path: '/chefHome',
        query: {DateArr: this.dateArr, StoresId: this.StoresId, seltype: this.erIfg}
      })
    },
    //第一个图表
    // SetEcharts() {
    //     // let colors = [
    //     //     '#FF9300',
    //     //     '#F6CA00',
    //     //     '#19BC4A',
    //     //     '#0084FF',
    //     //     '#8543E0',
    //     //     '#FF3D00'
    //     // ]
    //     // // console.log(richColor);
    //     // var chartDom = document.getElementById('main');
    //     // var myChart = echarts.init(chartDom);
    //     // let getWidth = chartDom.offsetWidth;
    //     // var option;
    //     // myChart.resize({
    //     //     width: getWidth,
    //     //     height: 250
    //     // })
    //     // option = {
    //     //     color: colors,
    //     //     // series: [
    //     //     //     {
    //     //     //         name: 'Access From',
    //     //     //         type: 'pie',
    //     //     //         radius: ['20%', '50%'],
    //     //     //         itemStyle: {
    //     //     //             borderRadius: 10,
    //     //     //             borderColor: '#fff',
    //     //     //             borderWidth: 2
    //     //     //         },
    //     //     //         label: {
    //     //     //             formatter: function (params) {
    //     //     //                 return `{b|${params.name}}\n{a|${params.data.bfb}} {e|${params.data.num}份} \n{c|${params.value}元}`
    //     //     //             },
    //     //     //             minMargin: 5,
    //     //     //             edgeDistance: 10,
    //     //     //             lineHeight: 15,
    //     //     //         },
    //     //     //         labelLine: {
    //     //     //             length: 15,
    //     //     //             length2: 0,
    //     //     //             maxSurfaceAngle: 80
    //     //     //         },
    //     //     //         labelLayout: function (params) {
    //     //     //             const isLeft = params.labelRect.x < myChart.getWidth() / 2;
    //     //     //             const points = params.labelLinePoints;
    //     //     //             points[2][0] = isLeft
    //     //     //                 ? params.labelRect.x
    //     //     //                 : params.labelRect.x + params.labelRect.width;
    //     //     //             console.log(points);
    //     //     //             return {
    //     //     //                 labelLinePoints: points
    //     //     //             };
    //     //     //         },
    //     //     //         data: [
    //     //     //             { value: 499900.00, name: '主食', bfb: '2.1%', num: '1300' },
    //     //     //             { value: 11398400.00, name: '炒菜', bfb: '55%', num: '111867' },
    //     //     //             { value: 7398400.00, name: '蒸菜', bfb: '35.4%', num: '61867' },
    //     //     //             { value: 984000.00, name: '酒水', bfb: '8.6%', num: '4867' },
    //     //     //             { value: 340000.81, name: '其他', bfb: '1.9%', num: '967' }
    //     //     //         ]
    //     //     //     }
    //     //     // ]
    //     //     series: [
    //     //         {
    //     //             name: '',
    //     //             type: 'pie',
    //     //             radius: ['30%', '45%'],       //饼图大小
    //     //             // labelLine: {    //图形外文字线
    //     //             //     normal: {
    //     //             //         length: 45,
    //     //             //         length2: 90,
    //     //             //         maxSurfaceAngle: 80
    //     //             //     }
    //     //             // },
    //     //             label: {
    //     //                 normal: {
    //     //                     formatter: '  {b|{b}}\n{c|{c}元}',     //图形外文字上下显示
    //     //                     formatter: function (params) {
    //     //                         // console.log(params.);
    //     //                         return `  {b|${params.name}}\n {a|${params.data.bfb}}{e${params.dataIndex}|${params.value}元}`
    //     //                     },
    //     //                     borderWidth: 30,
    //     //                     borderRadius: 4,
    //     //                     // padding: [0, -60],          //文字和图的边距
    //     //                     rich: {
    //     //                         a: {
    //     //                             color: '#333',
    //     //                             fontSize: 12,

    //     //                         },
    //     //                         b: {                        //name 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 20,
    //     //                             // align: 'left',
    //     //                             fontWeight: 600

    //     //                         },
    //     //                         c0: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 35,
    //     //                             color: '#FF9300',
    //     //                             // align: "left",

    //     //                         },
    //     //                         c1: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 40,
    //     //                             color: '#F6CA00',
    //     //                             // align: "left",

    //     //                         },
    //     //                         c2: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 40,
    //     //                             color: '#19BC4A',
    //     //                             // align: "left",

    //     //                         },
    //     //                         c3: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 40,
    //     //                             color: '#0084FF',
    //     //                             // align: "left",

    //     //                         },
    //     //                         c4: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             lineHeight: 40,
    //     //                             color: '#8543E0',
    //     //                             // align: "left",

    //     //                         },
    //     //                         c5: {
    //     //                             fontSize: 12,
    //     //                             lineHeight: 40,
    //     //                             color: '#FF3D00',
    //     //                             // align: "left",
    //     //                         },
    //     //                         e: {                   //value 文字样式
    //     //                             fontSize: 12,
    //     //                             // lineHeight: 30,
    //     //                             // align: "left"
    //     //                         }
    //     //                     }
    //     //                 }
    //     //             },
    //     //             // labelLayout: function (params) {
    //     //             //     const isLeft = params.labelRect.x < myChart.getWidth() / 2;
    //     //             //     const points = params.labelLinePoints;
    //     //             //     points[2][0] = isLeft
    //     //             //         ? params.labelRect.x
    //     //             //         : params.labelRect.x + params.labelRect.width;
    //     //             //     console.log(points);
    //     //             //     return {
    //     //             //         labelLinePoints: points
    //     //             //     };
    //     //             //             },
    //     //             // labelLine:{
    //     //             //     normal:{
    //     //             //         length:50,
    //     //             //         length2:60,
    //     //             //     }
    //     //             // },
    //     //             labelLayout: function (params) {
    //     //                 ;
    //     //                 const isLeft = params.labelRect.x < myChart.getWidth() / 2;
    //     //                 const points = params.labelLinePoints;
    //     //                 // Update the end point.
    //     //                 points[2][0] = isLeft
    //     //                     ? params.labelRect.x
    //     //                     : params.labelRect.x + params.labelRect.width;
    //     //                 return {
    //     //                     labelLinePoints: points
    //     //                 };
    //     //             },
    //     //             data: [
    //     //                 { value: 4300, name: '美团', bfb: '2.1%', num: '1300' },
    //     //                 { value: 111867, name: '微信', bfb: '55%', num: '111867' },
    //     //                 { value: 4867, name: '现金', bfb: '35.4%', num: '61867' },
    //     //                 { value: 61867, name: '支付宝', bfb: '8.6%', num: '4867' },
    //     //                 { value: 6982, name: '挂账', bfb: '1.9%', num: '967' },
    //     //                 { value: 8764, name: '抖音', bfb: '1.9%', num: '968' },
    //     //             ]
    //     //         }
    //     //     ]
    //     // };
    //     // option && myChart.setOption(option);

    // },
    zhangkai() {
      this.Ifgnum = this.CateringSix.length
    },
    chankai() {
      this.StoreshowOne = true
    },
    shuifan() {
      this.Ifgnum = 5
    },
    SetEcharts() {
      console.log(this.EchartsOne[0]);
      if (this.EchartsOne[0].length == 0 || this.notIfg) {
        return
      }
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      let getWidth = document.body.offsetWidth - 20;
      console.log(getWidth);
      if (getWidth >= 500) {
        getWidth = 500
      }
      myChart.resize({
        width: getWidth,
        height: 300
      })
      var option;
      var datas = this.EchartsOne
      option = {
        // title: {
        //   text: '阅读书籍分布',
        //   left: 'center',
        //   textStyle: {
        //     color: '#999',
        //     fontWeight: 'normal',
        //     fontSize: 14
        //   }
        // },
        series: datas.map(function (data, idx) {
          var top = idx * 33.3;
          return {
            type: 'pie',
            radius: ['30%', '45%'],
            // top: top + '%',
            height: '100%',
            left: 'center',
            width: getWidth,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{b}  {d}%}\n{value|{c}元}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 14,
                  color: '#333',
                  fontWeight: 400
                }
              },
              overflow: 'none',
            },
            // labelLine: {
            //   length: 10,
            //   length2: 0,
            //   maxSurfaceAngle: 80
            // },
            labelLayout: function (params) {
              console.log(params);
              ;
              const isLeft = params.labelRect.x < myChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                  ? params.labelRect.x
                  : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points
              };
            },
            data: data
          };
        })
      };
      option && myChart.setOption(option);

    },
    //第二个图表
    SetEchartsTow() {
      if (this.notIfg) {
        return
      }
      var chartDom = document.getElementById('mains');
      var myChart = echarts.init(chartDom);
      // let width = chartDom.clientWidth;
      // console.log(width);
      let length = this.chefName.length;
      let nums = 50
      if (this.chefName.length <= 1) {
        length = 1
        nums = 70
      }
      let widths = length * nums;
      var option;
      myChart.resize({
        width: widths,
        height: 300
      })
      option = {
        legend: {
          // right: '10%',
          data: ['生产数',]
        },
        xAxis: {
          data: this.chefName,
          axisLabel: {
            interval: 0, // 强制文字产生间隔
            rotate: 0, // 文字逆时针旋转45°
            textStyle: {
              // 文字样式
              color: '#333',
              fontSize: 10,
              // fontFamily: 'Microsoft YaHei'
            },
            show: true,
            formatter(value) {
              let str = value;
              if (value.length > 8) {
                str = value.slice(0, 7) + '...';
              }
              return str;
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            // min: 0,
            // // max: this.MoneyMax,
            axisLabel: {
              show: false, // 不显示坐标轴上的文字
            },
          },
          {
            type: 'value',
            // min: 0,
            // max: this.NumMax,
            interval: 5,
            axisLabel: {
              show: false, // 不显示坐标轴上的文字
            },
          }
        ],
        series: [
          {
            name: '生产数',
            type: 'bar',
            data: this.chefNum,
            itemStyle: {

              normal: {
                color: '#FF9300',
                label: {
                  show: true,
                  position: 'top',
                  color: '#666',
                  fontSize: 10,
                },
              }
            }
          },
          // {
          //     name: '金额（元）',
          //     type: 'line',
          //     // smooth: true,
          //     data: this.chefMoney,
          //     itemStyle: {
          //         normal: {
          //             color: '#F6CA00',
          //             label: {
          //                 show: true,
          //                 position: 'top',
          //                 color: '#666',
          //                 fontSize: 10,

          //             },
          //         }
          //     }
          // }
        ],
        grid: {
          left: "10px",
          right: '10px'
        }
      };

      myChart.setOption(option);

    },
    //改选择日期
    async SetErIfg(e) {
      this.date1 = new Date(this.date1);
      this.seltype = e
      this.loadingIFg = true
      this.pointerIFg = true
      if (e == 0) {
        this.date = this.GetDate(this.isDa())
        this.date = moment(this.date).format('YYYY/MM/DD')
        this.date1 = new Date(this.isDa())
        console.log(this.date);
        this.dateArr[0] = this.GetDate(this.date)
        this.dateArr[1] = this.GetDate(this.date)
        console.log(this.dateArr);
        await this.getData()
        // await this.getDateData(this.dateAr)
        await this.SetEcharts()
        await this.SetEchartsTow()
        // console.log(this.date1);
      } else if (e == 1) {
        let dateArr = this.ZhouMoney(this.isDa())
        // console.log(this.GetDate(this.date1));
        // this.date = `${dateArr[0]} - ${dateArr[1]}`
        this.date = moment(dateArr[0]).format('YYYY/MM/DD')
        this.date1 = new Date(moment(dateArr[0]).format('YYYY/MM/DD'))
        this.dateArr = dateArr
        await this.getData()
        // await this.getDateData(dateArr)
        await this.SetEcharts()
        await this.SetEchartsTow()
      } else if (e == 2) {
        // this.GetMoney(this.date1)
        this.dateArr = this.GetMoney(this.isDa())
        this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
        this.date1 = new Date(this.dateArr[0])
        await this.getData()
        // await this.getDateData(dateArr)
        await this.SetEcharts()
        await this.SetEchartsTow()
      } else if (e == 3) {
        // this.date = `${this.GetDate(this.date1)}至${ this.GetDate(this.date1)}`
        // this.date = `${this.GetDate(this.date1)}至${this.date = this.GetDate(this.date1)}`
        this.date = this.isDa()
        this.date1 = new Date(this.isDa())
        this.dateArr[0] = this.GetDate(this.isDa())
        this.dateArr[1] = this.GetDate(this.isDa())
        await this.getData()
        // await this.getDateData(this.dateArr)
        await this.SetEcharts()
        await this.SetEchartsTow()
      }
      // this.getDateData()
      await setTimeout(() => {
        this.loadingIFg = false
        this.pointerIFg = false
      }, 1000)
      this.erIfg = e
    },
    //格式处理
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}号`;
      }
      return val;
    },
    //确定和取消
    async TrueSet(dates) {
      this.loadingIFg = true
      this.pointerIFg = true
      // console.log(date);
      // this.date = this.GetDate(dates)
      this.show = false;
      this.date1 = dates
      this.date = moment(dates).format('YYYY/MM/DD')
      this.dateArr[0] = this.GetDate(this.date1)
      this.dateArr[1] = this.GetDate(this.date1)
      await this.getData()
      // await this.getDateData(this.dateArr)
      await this.SetEcharts()
      await this.SetEchartsTow()
      // if (e == 0) {
      //     if (this.erIfg == 0) {
      //         this.date = this.GetDate(this.date1)
      //         this.date = moment(this.date).format('YYYY/MM/DD')
      //         this.dateArr[0] = this.GetDate(this.date1)
      //         this.dateArr[1] = this.GetDate(this.date1)
      //         await this.getData()
      //         // await this.getDateData(this.dateArr)
      //         await this.SetEcharts()
      //         await this.SetEchartsTow()
      //     } else if (this.erIfg == 2) {
      //         this.dateArr = this.GetMoney(this.date1)
      //         this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
      //         await this.getData()
      //         // await this.getDateData(this.dateArr)
      //         await this.SetEcharts()
      //         await this.SetEchartsTow()
      //     } if (this.erIfg == 3 && date == undefined) {
      //         this.DateArr = []
      //         this.DateArr.push(this.GetDate(this.date1))
      //         this.show = false;
      //         this.ifgTime = false
      //         setTimeout(() => {
      //             this.minDate = this.date1
      //             this.show = true;
      //         }, 500)
      //     }
      //     if (date == 1) {
      //         this.show = false;
      //         this.ifgTime = true
      //         // setTimeout(())
      //         this.DateArr.push((this.GetDate(this.date1)))
      //         // this.date = `${this.DateArr[0]}至${this.DateArr[1]}`
      //         this.date = moment(this.DateArr[0]).format('YYYY/MM/DD')
      //         this.minDate = new Date(2021, 0, 1)
      //         this.dateArr = this.DateArr
      //         this.dateArr[1] = this.dateArr[1]
      //         setTimeout(async () => {

      //             await this.getData()
      //             // await this.getDateData(this.dateArr)
      //             await this.SetEcharts()
      //             await this.SetEchartsTow()
      //         }, 500)

      //     }
      // } else {
      // }

      await setTimeout(() => {
        this.loadingIFg = false
        this.pointerIFg = false
      }, 1000)
    },
    async TrueSet1(dates) {
      this.loadingIFg = true
      this.pointerIFg = true
      // console.log(date);
      // this.date = this.GetDate(dates)
      this.show = false;
      this.date1 = new Date()
      this.date = moment(new Date()).format('YYYY/MM/DD')
      this.dateArr[0] = this.GetDate(dates[0])
      this.dateArr[1] = this.GetDate(dates[1])
      await this.getData()
      // await this.getDateData(this.dateArr)
      await this.SetEcharts()
      await this.SetEchartsTow()
      await setTimeout(() => {
        this.loadingIFg = false
        this.pointerIFg = false
      }, 1000)
    },
    async Confirm(date) {
      console.log(date);
      this.loadingIFg = true
      this.loadingIFg = true
      if (new Date(date[1].value) > this.maxDate || new Date(date[1].value) < this.minDate) {
        Toast.fail('暂无数据');
        this.loadingIFg = false
        this.pointerIFg = false
        return
      }
      this.show = false
      setTimeout(async () => {
        let dateArr = this.ZhouMoney(date[1].value)
        this.date1 = new Date(dateArr[0])
        console.log(this.date1);
        // this.date = `${dateArr[0]}至${dateArr[1]}`
        this.date = moment(dateArr[0]).format('YYYY/MM/DD')
        this.dateArr = dateArr

        await this.getData()
        await this.SetEcharts()
        await this.SetEchartsTow()

        this.loadingIFg = false
        this.pointerIFg = false
      }, 500)


    },
    quxiao(e) {
      this.show = false
    },
    //隐藏和显示
    showPopup() {
      this.show = true
    },
    GetLeiMoney() {
      this.zhankai = true
      console.log(this.zhankai);
      this.newLeiMoney = this.LeiMoney
    },
    //周一和周末
    ZhouMoney(e) {
      //     var now = new Date(e);
      //    let week= moment(e).format("E")
      //     console.log(this.GetDate(this.date1), 1);
      //     var nowTime = now.getTime();
      //     var day = now.getDay();
      //     var oneDayTime = 24 * 60 * 60 * 1000;
      //     console.log(this.GetDate(this.date1), 2);
      //     //显示周一
      //     var MondayTime = nowTime - (day - 1) * oneDayTime;
      //     //显示周日
      //     var SundayTime = nowTime + (7 - day) * oneDayTime;
      //     //初始化日期时间
      //     var monday = new Date(MondayTime);
      //     console.log(this.GetDate(this.date1), 5);
      //     var sunday = new Date(SundayTime);
      //     console.log(this.GetDate(this.date1), 6);
      //     this.monday = this.GetDate(monday)
      //     console.log(this.GetDate(this.date1), 7);
      //     this.sunday = this.GetDate(sunday)
      //     console.log(this.GetDate(this.date1), 8);

      var weekOfday = moment(e).format('E');//计算今天是这周第几天
      console.log(weekOfday);
      this.monday = moment(e).subtract(weekOfday - 1, 'days').format('YYYY-MM-DD');//周一日期
      this.sunday = moment(e).add(7 - weekOfday, 'days').format('YYYY-MM-DD');
      console.log(this.monday);
      return [this.monday, this.sunday]
    },
    //获取日期 这个月的第一天和最后一天
    GetMoney(date) {
      let date1 = new Date(date)
      const MounthOne = new Date(date1.getFullYear(), date1.getMonth(), 1);
      // 将日期设为下个月的1号
      date1.setMonth(date1.getMonth() + 1, 0);
      // 获取本月的最后一天
      let MonthTow = date1;
      this.date = this.GetDate(MounthOne)
      return [this.GetDate(MounthOne), this.GetDate(MonthTow)]
    },
    SetLeiMoney() {
      this.zhankai = false
      this.newLeiMoney = this.LeiMoney.slice(0, 3)
    },
    showIfg() {
      this.$store.commit("SetStoreshow", false)
    },
    SetShow() {
      this.show = true
    },
    SetPageIfg(e, title,) {
      let datas = {
        title: title,
        flg: true,
        data: title === '美团' ? this.MtGetMel : this.DyGetMel,
      }
      e.price1 == 0 || this.$store.commit('SetPageIfg', datas)
    },
    SetPageIfg1Loaging(e, title,) {
      this.openLoading(() => {
        this.SetPageIfg(e, title,)
      }, 500)
    },
    SetDate(e) {
      //判断是不是日期是不是前一天或者前两天
      this.lodDate = this.date
    },
    handleCommand(e) {
      this.title = e
    },
    navto(e) {
      this.swiper.slideTo(e - 1, 100, false)
    },
    handleScroll() {
      if (Math.trunc(document.documentElement.scrollTop) >= this.oft) {
        this.stickyHeader.style.position = 'fixed';
        this.stickyHeader.style.top = '0';
        this.classIfg = false
      } else if (Math.trunc(document.documentElement.scrollTop) < this.oft) {
        this.stickyHeader.style.position = 'static'
        this.stickyHeader.style.offsetTop = this.oft;
        this.classIfg = true
      }
    },
    formatDate(date) {
      let formattedDate = this.GetDate(date);
      if (this.erIfg == 1) {
        this.ZhouMoney(formattedDate)
      }
      return formattedDate
    },
    GetDate(date1) {
      let date = new Date(date1)
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    //弹出loading组件
    openLoading(func, Time) {
      this.loadingIFg = true
      this.pointerIFg = true
      setTimeout(() => {
        func()
        this.loadingIFg = false
        this.pointerIFg = false
      }, Time)
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
    nextTa(ifg) {
      this.loadingIFg = true
      this.pointerIFg = true
      setTimeout(async () => {
        //加一天
        if (this.erIfg == 0) {
          if (ifg == 1) {
            let dateTime = new Date(this.date);
            dateTime = dateTime.setDate(dateTime.getDate() + 1);
            let dateTimes = new Date(dateTime);

            //判断日期是不是超过了最大日期和最新日期
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            // this.date = this.GetDate(dateTimes)
            this.date = moment(dateTimes).format('YYYY/MM/DD')
            this.dateArr[0] = this.GetDate(dateTimes)
            this.dateArr[1] = this.GetDate(dateTimes)
            this.$nextTick(() => {
              this.$refs.vanCalendar.reset(new Date(this.date1))
            })
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()

          } else {
            let dateTime = new Date(this.date);
            dateTime = dateTime.setDate(dateTime.getDate() - 1);
            let dateTimes = new Date(dateTime)
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            // this.date = this.GetDate(dateTimes)
            this.date = moment(dateTimes).format('YYYY/MM/DD')
            this.dateArr[0] = this.GetDate(dateTimes)
            this.dateArr[1] = this.GetDate(dateTimes)
            this.$nextTick(() => {
              this.$refs.vanCalendar.reset(new Date(this.date1))
            })
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()

          }       //加一周
        } else if (this.erIfg == 1) {
          if (ifg == 1) {
            let dateArr = this.ZhouMoney(this.date1)
            let dateTime = new Date(dateArr[0]);
            dateTime = dateTime.setDate(dateTime.getDate() + 7);
            let dateTimes = new Date(dateTime);
            //判断日期是不是超过了最大日期和最新日期
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            let dateArr1 = this.ZhouMoney(this.date1)
            // this.date = `${dateArr1[0]}至${dateArr1[1]}`
            this.date = moment(dateArr1[0]).format('YYYY/MM/DD')
            this.dateArr = dateArr1
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()

          } else {
            let dateArr = this.ZhouMoney(this.date1)
            let dateTime = new Date(dateArr[0]);
            dateTime = dateTime.setDate(dateTime.getDate() - 7);
            let dateTimes = new Date(dateTime)
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            let dateArr1 = this.ZhouMoney(this.date1)
            // this.date = `${dateArr1[0]}至${dateArr1[1]}`
            this.date = moment(dateArr1[0]).format('YYYY/MM/DD')
            this.dateArr = dateArr1
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()
          }

        } else if (this.erIfg == 2) {//加一个月
          console.log(1);
          if (ifg == 1) {
            let dateTime = new Date(this.date1);
            //变为下个月第一天
            dateTime = dateTime.setMonth(dateTime.getMonth() + 1);
            let dateTime1 = new Date(dateTime)
            dateTime1 = dateTime1.setDate(1);
            let dateTimes = new Date(dateTime1);
            console.log(this.GetDate(dateTimes));
            //判断日期是不是超过了最大日期和最新日期
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            this.dateArr = this.GetMoney(this.date1)
            this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()

          } else {
            let dateTime = new Date(this.date1);
            dateTime = dateTime.setMonth(dateTime.getMonth() - 1);
            let dateTime1 = new Date(dateTime)
            dateTime1 = dateTime1.setDate(1);
            let dateTimes = new Date(dateTime1);
            if (dateTimes > this.maxDate || dateTimes < this.minDate) {
              Toast.fail('日期选择错误');
              this.loadingIFg = false
              this.pointerIFg = false
              return
            }
            this.date1 = dateTimes
            this.dateArr = this.GetMoney(this.date1)
            this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
            await this.getData()
            await this.SetEcharts()
            await this.SetEchartsTow()
          }
        }
        // await this.GetPost(this.data, this.StoresId)
        this.SwiperIndex = 0

        // await this.navto(this.SwiperIndex + 1)
        this.loadingIFg = false
        this.pointerIFg = false
      }, 500)
    },
    async Setloading(a, time) {
      this.loadingIFg = true
      this.pointerIFg = true
      await setTimeout(() => {
        a()
        this.loadingIFg = false
        this.pointerIFg = false
      }, time)
    },
    GetDates(data) {
      const year = data.getFullYear();
      const month = (data.getMonth() + 1).toString().padStart(2, '0');
      const day = data.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate
    },
    GetDateOne(data) {
      const year = data.getFullYear();
      const month = (data.getMonth() + 1).toString().padStart(2, '0');
      const day = data.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}/${month}/${day}`;
      return formattedDate
    },
    mouseoverDoubt(itme) {
      itme.tole = 1
      setTimeout(() => {
        itme.tole = 0
      }, 5000)
    },
    //转换时间格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return Y + M + D + h + m;
    },
    //转换时间戳
    timestamps(date) {
      let dates = new Date(date)
      var timestamp = Date.parse(dates);
      return this.timestampToTime(timestamp)
    },
    async getData() {
      this.getDateData(this.dateArr)
      this.notIfg = false
      this.EchartsOne = []
      console.log(this.dateArr);
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetRealTimeReportData`, PostData)
      //  console.log();
      //  console.log(ReturnTag);
      let datas = unZip(ReturnTag)
      datas = JSON.parse(datas)
      this.dataValue = datas
      console.log(this.dataValue);
      if (this.dataValue.RealTimeResultList[0].payamount == 0) {
        this.notIfg = true
        // return
      }
      this.dataValue.RealTimeResultList[0].payamount = (this.dataValue.RealTimeResultList[0].payamount).toFixed(2)
      this.dataValue.RealTimeResultList[0].nopayamount = (this.dataValue.RealTimeResultList[0].nopayamount).toFixed(2)
      this.dataValue.RealTimeResultList[0].settleamount = (this.dataValue.RealTimeResultList[0].settleamount).toFixed(2)
      this.CateringOne[0].price = parseInt(this.dataValue.RealTimeResultList[0].avgtime) + '分钟'
      this.CateringOne[1].price = this.dataValue.RealTimeResultList[0].dintableqty + '个'
      this.CateringOne[2].price = this.dataValue.RealTimeResultList[0].havemealqty + '人'
      this.CateringTow[0].price = this.dataValue.RealTimeResultList[0].productqty + '个'
      this.CateringTow[1].price = this.dataValue.RealTimeResultList[0].beverageqty

      this.dataValue.SoldResultList[0].operatingincome = (this.dataValue.SoldResultList[0].operatingincome).toFixed(2)
      let zongMoney = this.dataValue.RealTimeResultList[0].settleamount
      console.log(this.dataValue.RealTimeResultList[0]);
      this.EchartsOne = [
        [
          {
            value: this.dataValue.RealTimeResultList[0].wxamount,
            name: '微信',
            bfb: (this.dataValue.RealTimeResultList[0].wxamount / zongMoney * 100).toFixed(2) + '%'
          },
          {
            value: this.dataValue.RealTimeResultList[0].alipayamount,
            name: '支付宝',
            bfb: (this.dataValue.RealTimeResultList[0].alipayamount / zongMoney * 100).toFixed(2) + '%'
          },
          {
            value: this.dataValue.RealTimeResultList[0].cashamount,
            name: '现金',
            bfb: (this.dataValue.RealTimeResultList[0].cashamount / zongMoney * 100).toFixed(2) + '%'
          },
          {
            value: this.dataValue.RealTimeResultList[0].creditamount,
            name: '挂账',
            bfb: (this.dataValue.RealTimeResultList[0].creditamount / zongMoney * 100).toFixed(2) + '%'
          },
          {
            value: this.dataValue.RealTimeResultList[0].Mamount,
            name: '美团',
            bfb: (this.dataValue.RealTimeResultList[0].Mamount / zongMoney * 100).toFixed(2) + '%'
          },
          {
            value: this.dataValue.RealTimeResultList[0].Damount,
            name: '抖音',
            bfb: (this.dataValue.RealTimeResultList[0].Damount / zongMoney * 100).toFixed(2) + '%'
          },
        ]
      ]
      // console.log(this.EchartsOne);
      this.EchartsOne[0] = this.EchartsOne[0].filter(e => e.value !== 0)
      console.log(this.EchartsOne);
      // { title: '堂食', percent: '85%', name: "到店人数", price: '86人' },
      this.CateringThree[0].percent = this.dataValue.SoldResultList[0].tangspercent
      this.CateringThree[0].price = this.dataValue.SoldResultList[0].havemealqty + "人"
      this.CateringThree[1].percent = this.dataValue.SoldResultList[0].selfpercent
      this.CateringThree[1].price = (this.dataValue.SoldResultList[0].avgspend).toFixed(2) + "元"
      this.CateringThree[2].percent = this.dataValue.SoldResultList[0].takeawaypercent
      this.CateringThree[2].price = (this.dataValue.SoldResultList[0].refundamount).toFixed(2) + "元"
      // console.log(this.CateringThree[0]);
      await this.getCateringfoue()
      await this.getCateringfive()
      await this.getCateringSix()
      await this.getCateringServer()
      console.log(4);

    },
    async getCateringfoue() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
        seltype: this.seltype
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetCustomerInforReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      this.Cateringfoue[0].name = dataOne[0].turnoverrate
      this.Cateringfoue[1].name = dataOne[0].occupancyrate
      this.Cateringfoue[0].TongPercent = dataOne[0].YOYDifturnoverrate
      this.Cateringfoue[0].TongIfg = dataOne[0].YOYturnoverDif
      this.Cateringfoue[0].HuanPercent = dataOne[0].QOQDifturnoverrate
      this.Cateringfoue[0].HuanIfg = dataOne[0].QOQturnoverDif
      this.Cateringfoue[1].TongPercent = dataOne[0].YOYDifoccupancyrate
      this.Cateringfoue[1].TongIfg = dataOne[0].YOYoccupancyDif
      this.Cateringfoue[1].HuanPercent = dataOne[0].QOQDifoccupancyrate
      this.Cateringfoue[1].HuanIfg = dataOne[0].QOQoccupancyDif
      // this.Cateringfoue[].TongPercent = dataOne[0].YOYDifturnoverrate
      // this.Cateringfoue[0].colorIfg = dataOne[0].YOYturnoverDif
    },
    async getCateringfive() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetProRankingReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas), 'xxaaaaaaaaaaaaaaaa');
      let dataOne = JSON.parse(datas)
      this.CateringfiveData = dataOne
      console.log(dataOne);
      this.Cateringfive = dataOne.SalesResultList

      if (dataOne.SalesResultList.length > 0) {
        dataOne.SalesResultList.forEach((e, index) => {
          this.Cateringfive[index].img = require(`../../assets/img/${index}.png`)
        })

        // this.Cateringfive[1].img = require("../../assets/img/1.png")
        // this.Cateringfive[2].img = require("../../assets/img/2.png")
        // dataOne.SalesResultList.forEach((e, index) => {
        //     this.Cateringfive[index].title = e.productname
        //     this.Cateringfive[index].percent = e.productratio
        //     this.Cateringfive[index].num = e.productqty
        //     this.Cateringfive[index].price = e.productamount
        // })
      }

    },
    async getzhou() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetRealTimeHistoryReportData`, PostData)
      let datas = unZip(ReturnTag)
      let dataOne = JSON.parse(datas)
      console.log(dataOne);
      this.zhoushang = dataOne
    },
    async getCateringSix() {
      this.shengcaiIfg = false
      this.CateringSix = []
      this.getzhou()
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetProProduceReportData`, PostData)
      let datas = unZip(ReturnTag)
      let dataOne = JSON.parse(datas)
      // console.log(dataOne,'XXXXXXXXXXXXXXXXXXXXXX2');
      this.chefName = []
      this.chefNum = []
      this.chefMoney = []
      console.log(dataOne, 'ppppppppppppp');
      if (dataOne.length == 0) {
        this.shengcaiIfg = true
        return
      }
      console.log(dataOne);
      this.MoneyMax = dataOne[0].produceamount

      this.NumMax = dataOne[0].producenum
      // { name: "赵钱孙李", num: 12, time: 8, SellOut: 98233, price: '378921.20', },
      dataOne.forEach(e => {
        e.name = e.personname
        e.num = e.timeoutnum
        e.time = e.estimateqty
        e.SellOut = e.producenum
        e.price = e.produceamount
        if (this.MoneyMax < e.produceamount) {
          this.MoneyMax = e.produceamount
        }
        if (this.NumMax < e.producenum) {
          this.NumMax = e.producenum
        }
        this.chefName.push(e.personname)
        this.chefNum.push(e.producenum)
        this.chefMoney.push(e.produceamount)
      })
      console.log(this.chefName, this.chefNum, this.MoneyMax, this.NumMax);
      this.CateringSix = dataOne
    },
    async getCateringServer() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetActivityReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      console.log(dataOne);
      this.CateringServerData = dataOne
      // { name: "团购套餐", num: 30, price: "12946.50" },
      this.CateringServer[0].num = dataOne[0].settlesetmealqty
      this.CateringServer[0].price = dataOne[0].settlesetmealamount
      this.CateringServer[1].num = dataOne[0].voucheraqty
      this.CateringServer[1].price = dataOne[0].voucheramount
      // { name: "抖音", zhanbei: "42%", num: 12, money: "11111288.50" },
      this.CateringEight[0].zhanbei = dataOne[0].Dratio
      this.CateringEight[0].num = dataOne[0].Dqty
      this.CateringEight[0].money = dataOne[0].Damount
      this.CateringEight[1].zhanbei = dataOne[0].Mratio
      this.CateringEight[1].num = dataOne[0].Mqty
      this.CateringEight[1].money = dataOne[0].Mamount
      this.CateringEight[2].zhanbei = dataOne[0].Xratio
      this.CateringEight[2].num = dataOne[0].Xqty
      this.CateringEight[2].money = dataOne[0].Xamount
    },
    getDateData(dateArr) {
      // console.log(moment(this.dateArr[1]).day(),'周一');
      console.log(dateArr);
      this.dateData[0] = {
        y: moment(dateArr[0]).format('YYYY'),
        m: moment(dateArr[0]).format('MM'),
        d: moment(dateArr[0]).format('DD'),
        z: this.ChineaNums[moment(dateArr[0]).day()]
      }
      this.dateData[1] = {
        y: moment(dateArr[1]).format('YYYY'),
        m: moment(dateArr[1]).format('MM'),
        d: moment(dateArr[1]).format('DD'),
        z: this.ChineaNums[moment(dateArr[1]).day()]
      }
    },
    isDa() {
      let date = ''
      const now = moment();

      // 创建指定时间，例如15:00
      const specificTime = moment('09:00', 'HH:mm');

      // 判断当前时间是否小于或等于指定时间
      if (now.isBefore(specificTime) || now.isSame(specificTime)) {
        date = moment(new Date()).subtract(1, 'days').format("YYYY/MM/DD")
        console.log('当前时间小于或等于指定时间');
      } else {
        date = moment(new Date()).format("YYYY/MM/DD")
        console.log('当前时间大于指定时间');
      }
      return date
    },
    async mounteds() {
      //获取前一天的数据
      // let data = new Date();
      // console.log(this.ZhouMoney('2024-03-18'), 'xxxxxxxxx');
      // this.GetMoney(data)
      // let dateTime = new Date(data);
      // dateTime = dateTime.setDate(dateTime.getDate());
      // let dateTimes = new Date(dateTime)
      // const year = dateTimes.getFullYear();
      // const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
      // const day = dateTimes.getDate().toString().padStart(2, '0');
      // const formattedDate = `${year}/${month}/${day}`;


      // if(moment(new Date()).for)
      this.date = this.isDa()
      this.date1 = new Date(this.isDa())
      // console.log(this.date1=new Date(this.isDa()));
      let dates = JSON.parse(sessionStorage.getItem('time'))
      this.erIfg = JSON.parse(sessionStorage.getItem('erifg'))
      // this.dateArr[0] = this.date
      // this.dateArr[1] = this.date + ' 23:59:59'
      if (dates == undefined || dates == null) {
        this.dateArr[0] = this.date
        this.dateArr[1] = this.date
        // this.getDateData( this.dateArr)
        this.erIfg = 0
      } else {
        this.dateArr = dates
        // this.getDateData(this.dateArr)
        if (this.erIfg == 0) {
          this.date = moment(this.dateArr[0]).format("YYYY/MM/DD")

        } else if (this.erIfg == 1) {
          this.dateArr = this.ZhouMoney(this.dateArr[0])
          this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
        } else if (this.erIfg == 2) {
          console.log(this.dateArr[0]);
          this.dateArr = this.GetMoney(this.dateArr[0])
          this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
        } else if (this.erIfg == 3) {
          this.date = moment(this.dateArr[0]).format('YYYY/MM/DD')
        }
      }
      console.log(this.dateArr);
      let vm = this

      // this.swiper = new Swiper(".swiper-container", {
      //     loop: true,
      //     mousewheel: true,
      //     keyboard: true,
      //     observer: true,
      //     observeParents: true,
      //     on: {
      //         slideChange: function () {
      //             // -> 这里的this指的是Swiper的this对象,不是vue的,所以要将VUe的this对象声明vm指向vue实例,这里就是轮播图的切换下标
      //             vm.SwiperIndex = this.realIndex
      //             vm.GetRealData(this.realIndex)
      //             //改变时间
      //             // let dateTime = new Date(vm.lodDate);
      //             // dateTime = dateTime.setDate(dateTime.getDate() + vm.SwiperIndex);
      //             // let dateTimes = new Date(dateTime)
      //             // const year = dateTimes.getFullYear();
      //             // const month = (dateTimes.getMonth() + 1).toString().padStart(2, '0');
      //             // const day = dateTimes.getDate().toString().padStart(2, '0');
      //             // const formattedDate = `${year}-${month}-${day}`;
      //             // console.log(formattedDate);
      //             // vm.date = formattedDate
      //         }
      //     },
      //     navigation: {
      //         // nextEl: ".next_text",
      //         // prevEl: ".pre_text"
      //     }
      // });
      await this.GetStoreId()
      await this.GetPost(this.date, this.Stores[0].id)
      await this.getData()

      // console.log(this.Stores[0].name);
      this.indexs = this.indexs < 0 ? 0 : this.indexs
      this.value1 = this.option1[this.indexs].text
      //不能看明天的
      let date = new Date();
      this.maxDate = this.AddDay(date)
      // this.$nextTick(() => {
      //     this.$refs.vanCalendar.reset(new Date(this.date))
      // })

    },
    //加一天
    AddDay(date) {
      let dateTime = new Date(date);
      dateTime = dateTime.setDate(dateTime.getDate());
      let dateTimes = new Date(dateTime)
      return dateTimes;
    },
    async GetPost(date, id) {
      let PostData = {
        storeid: id, //门店id
        beginDate: this.date, //开始时间
        endDate: `${this.date}` //截止时间
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetSettleWorkReportData`, PostData)
      let cunZips = unZip(ReturnTag)
      this.reportData = JSON.parse(cunZips)
      console.log(3);
    },
    SetNum(data) {
      let qtys = 0
      let money = 0
      data.mtvoucher.forEach(element => {
        qtys = qtys + Number(element.qty)
        money = money + Number(element.amount)
      });
      data.mtsetmeal.forEach(element => {
        qtys = qtys + Number(element.qty)
        money = money + Number(element.payamount)
      });

      return {qtys, money}
    },
    convertToPercentage(num) {
      return (num * 100).toFixed(2) + "%";
    },
    //获取门店的id
    async GetStoreId() {
      // console.log(this.userid);
      if (this.userid !== null && this.userid !== undefined) {
        this.userid = this.userid.replaceAll('"', '')
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetStoresByQWChatUserid`, {
        userid: this.userid
      })

      let cunZips = unZip(ReturnTag)
      this.Stores = JSON.parse(cunZips)
      console.log(this.Stores);
      // alert(this.Stores)
      //门店title 赋值给option1
      let index = 0
      this.Stores.forEach(e => {
        this.option1.push({
          text: e.name,
          value: index
        })
        index++
      })
      for (let index = 0; index < this.Stores.length; index++) {
        this.option1[index].text = this.Stores[index].name
      }
      this.indexs = 0;
      if (this.storeid !== undefined && this.storeid !== null && this.storeid !== '' && this.userid !== undefined && this.userid !== null && this.userid !== '' || this.storeid !== undefined && this.storeid !== null && this.storeid !== '') {
        this.indexs = this.Stores.findIndex(e => {
          return e.id === this.storeid
        })
      }
      if (this.indexs < 0) {
        await this.$message.closeAll()
        await this.$message.error("你没有进入该店的权限")
        throw new Error('你没有进入该店的权限')
        return false
      }
      this.StoresId = this.Stores[this.indexs].id
      console.log(
          this.Stores
      );
    },
    //改变门店
    async SetDropdown(index) {
      this.loadingIFg = true
      this.pointerIFg = true
      await setTimeout(async () => {
        let indexs = this.Stores.findIndex(e => e.name === index)
        //    console.log(indexs);
        this.GetPost(this.date, this.Stores[indexs].id)
        this.StoresId = this.Stores[indexs].id
        await this.getData()
        await this.SetEcharts()
        await this.SetEchartsTow()
        this.loadingIFg = false
        this.pointerIFg = false
      }, 1000)
    },
    async SetPageedIfg() {
      // console.log("xxxxxxxxxxx");
      // setTimeout(() => {
      //     this.PageedIfg = true
      //     console.log(this.loadingIFg);
      // }, 1000)

      setTimeout(async () => {
        await this.SetEcharts()
        await this.SetEchartsTow()
      }, 500)
    },
    async GetPush() {
      await this.mounteds()
      await this.SetPageedIfg()
      this.newLeiMoney = this.LeiMoney.slice(0, 3)
    },
    async getopenid(code, agentid) {
      let datas = {
        code: code,
        agentid: agentid,
        // agentid: 1000032
      }
      let {ReturnTag} = await this.$server.post('/WeCom/GetUserid', datas)
      let data = unZip(ReturnTag);


      if (data !== null) {
        var loginurl = data; //登录路径
        this.userid = loginurl; //获取了usid
        // alert(this.userid)
        console.log(this.userid);
        this.$cookies.set('userid', this.userid)
        sessionStorage.setItem('userid', this.userid)
        this.GetPush()
      } else {
        await this.$message.closeAll()
        await this.$message.error("你没有进入权限")
        throw new Error('你没有进入权限')
      }
    },
    //判断第一班的时间是不是大于第二班的时间 进行排序
    // dates(){
    //     this.EchartsData.date=['10:00','10:30','11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00','22:30','23:00','23:30']
    //     this.EchartsData.data=[125,150,245,250,130,150,140,160,150,180,190,200,190,220,230,220,250,150,270,280,290,220,310,320,330,290,350,360]
    //     this.$store.commit('SetEchartsData', this.EchartsData)
    //     console.log(this.EchartsData);
    // }
  },
  computed: {
    PageIfg() {
      return this.$store.state.PageIfg
    },
    Storeshow() {
      return this.$store.state.Storeshow
    },
    showIndex() {
      return this.$store.state.showIndex
    },
    showData() {
      return this.$store.state.showData
    },

  },
  async mounted() {
    //  this.dates()
    // this.$route.query.storeid=
    // // this.$route.query.userid !==
    // let datas= '"FengJun"'
    // // console.log(datas);
    // datas=datas.replaceAll('"','')
    // console.log(datas);
    // let po = unZip("eJwljkEOgjAQAL+y6ZmULkilJMaHiAcCizRCF0oRifHvErxOMpMRn1KQ9zU3VIpCK5Wo6CDD/NhBKRwHqPqeVwgMVV3TPEPreYCNFw92jKCzLhRwwzOqPDVK4SnReYomN1pjkuE9+gt2LACTVGZaolES0UQwsCewrt3TAboQxrmIYx7JyZX9U65k39bJaZI1D3FDr8Dcx9NCfrvS5bgtxVf8AHROPU4=");
    // console.log(po);
    this.loadingIFg = true
    this.pointerIFg = true
    let storeid = this.$route.query.storeid
    let storeids = JSON.parse(sessionStorage.getItem('StoresId'))
    if (storeids !== undefined && storeids !== null && storeids !== '') {
      this.storeid = storeids
    }
    let userid = this.$route.query.userid
    // storeid='7900D272-DAF3-4DBB-AD29-4DB5E1437D5E'
    // userid='XieJianGuo'
    document.title = this.$route.meta.title

    if (storeid !== undefined && storeid !== null && storeid !== '' && userid !== undefined && userid !== null && userid !== '') {
      this.userid = userid
      console.log(this.userid, this.$route.query.userid);
      this.storeid = storeid
      await this.GetPush()
    } else {
      this.agentid = this.$route.query.agentid
      this.code = this.$route.query.code
      this.userid = this.$cookies.get('userid')
      this.userid = sessionStorage.getItem('userid')
      console.log(this.userid);
      let selectedstore = this.$cookies.get('selectedstore')
      if (selectedstore != null && selectedstore != '' && selectedstore != undefined) {
        this.selectedstore = selectedstore
      }
      if ((this.code != null && this.code != "" && this.code != undefined) && (this.userid == null || this.userid == '' || this.userid == undefined)) {
        // console.log(123456);
        await this.getopenid(this.code, this.agentid);
      } else if (this.userid != null && this.userid != '' && this.userid != undefined) {
        await this.GetPush()
      }
    }
    // await this.GetPush()
    await setTimeout(async () => {
      this.loadingIFg = false
      this.pointerIFg = false
    }, 1000)

  },
  watch: {
    date1: {
      handler(n, o) {
        this.$store.commit('SetDate', n)
      },
      immediate: true
    },
    maxDate: {
      handler(n, o) {
        this.$store.commit('SetmaxDate', n)
      },
      deep: true,
      immediate: true
    },
    minDate: {
      handler(n, o) {
        this.$store.commit('SetminDate', n)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/hotcss/hotcss-master/src/px2rem.scss';

[v-cloak] {
  display: none;
}

.font-smaii {
  color: rgb(102, 102, 102);
  font-size: 16px;
  font-weight: 400;
}

.font-num {
  margin-top: 8px;
  color: rgb(51, 51, 51);
  font-size: 16px;
  font-weight: 500;
}

.font-14 {
  color: rgb(153, 153, 153);
  font-size: 12px;
  font-weight: 400;
}

.van-popup {
  border-radius: 12px;
}

.opne .van-popup {
  width: 90%;
}

.tdOneWidth {
  width: 80px !important;
}

* {
  font-family: Alibaba;
}

.font-14-p {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}


.diplay {
  display: none !important;
}

::v-deep .el-rate__text {
  display: none;
}

.swiper-container {
  width: 100%;
}

::v-deep .van-dropdown-item__option--active {
  color: #000;
}

::v-deep .van-dropdown-menu__title--active::after {
  color: #000;
}

::v-deep .van-dropdown-item__option--activ {
  color: #000;
}

::v-deep .van-calendar__weekdays {
  background-color: #f4efe9;
}

::v-deep .van-calendar__header-subtitle {
  background-color: #f4efe9;
}

#mains {
  padding: 0;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  overflow: scroll;
}

//修改elementUI样式中日期选择器
::v-deep .el-input__inner {
  // height: 30px;
  // width: 100%;
  min-width: 220px;
  text-align: center;
  border: none !important;
  // margin: 0 !important;
  padding: 0 !important;
  color: rgb(51, 51, 51);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

::v-deep .el-input__suffix {
  right: 0 !important;
}

::v-deep .el-input__icon {
  display: flex;
  align-items: center;
}

::v-deep .van-dropdown-menu {
  width: 100%;
}

::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
}

.fxid {
  border: px2rem(0.5) solid #DDDDDD;
}

::v-deep .van-ellipsis {
  color: #333;
  text-align: center;
  font-family: Alibaba;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.el-dropdown-menu {
  width: 134px;
}

//使点击事件失效
.ButtonEvents {
  pointer-events: none;
}

.content {
  position: relative;
  max-width: 520px;
  min-width: px2rem(320);
  margin: auto;
  // width: 100%;
  height: 100%;

  //日期选择器

  .logo {

    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 163px;
      height: 64px;
    }
  }

  //导航栏
  .tent_nav {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80px;
    background-color: #f5f5f5;

    .nav_contet {
      display: flex;
      align-items: center;

      .nav_one {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #cccc;
        background-color: #DDD;
      }

      .one_tow {
        width: 36px;
        height: 1px;
        background: #DDD;
        margin-left: 8px;
        margin-right: 8px;
      }

      .res {
        background-color: #CA0000;
      }
    }

    .nav_text {
      display: flex;
      // width: 180px;
      justify-content: space-between;
      margin-top: 8px;

      div {

        color: #DDD;
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
      }

      .ddd {
        color: #333;
      }
    }
  }

  .fiexds {
    width: calc(100% - 16px) !important;
  }

  .flexdx {
    width: calc(100% - 16px) !important;
  }

  .fiexd {
    // position: fixed;
    position: static;
    max-width: calc(520px - 16px);
    min-width: px2rem(320);
    z-index: 30;
    background-color: #f5f5f5;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;

    .one_top {
      // position: fixed;
      // top: 50%;
      // // left: 0;
      border-radius: 10px;
      background-color: #ffffff;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      padding: 12px;
      position: sticky;
      // width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;

      .top_imgs {
        width: 44px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .top_text {
        margin-left: 8px;
        color: #C2986E;
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }
    }

  }

}

.day_xue {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .day_xue_da {
    width: 100%;
    // padding: 10px;
    display: flex;
    justify-content: space-between;
    // margin-top: 8px;
    // margin-bottom: 8px;
    margin-left: 12px;
    margin-right: 12px;
    background-color: #C2986E;
    border-radius: 16px;
    padding: 2px;
    height: 32px;
    color: #fff;

    div {
      width: 86px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      color: #fff;
      text-align: center;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }

    .xueze {
      background-color: #ffffff;
      color: #C2986E;
      text-align: center;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }
}

.onsb {
  padding: 12px;
  display: flex;
  flex-direction: column;

  .fengjiexiao {
    width: 100%;
    border: px2rem(1) dashed #f5f5f5;
    margin-top: px2rem(0) !important;
    margin-bottom: px2rem(0) !important;
  }

  .throw_content_title {
    color: rgb(51, 51, 51);
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
  }

  .throw_content_text {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;

    .content_max {
      margin-left: 0px !important;
    }

    .content_text {
      width: 32%;
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .text_title {
        display: flex;
        justify-content: center;
        color: rgb(102, 102, 102);
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;

        .title_percent {
          margin-left: 8px;
          color: #C2986E;
          font-family: Alibaba;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          // line-height: 18px;
        }

      }

      .text_textOne {
        margin-top: 12px;
        width: 100%;
        border-radius: 5px;
        background-color: #F8F8F8;
        display: flex;
        flex-direction: column;
        color: #666;
        padding: 16px 0;
        text-align: center;
        font-family: Alibaba;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;

        .text_price {
          margin-top: 16px;
          color: rgb(51, 51, 51);

          text-align: center;
          font-family: Alibaba;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
        }
      }
    }
  }
}

// 标题样式
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 44px;
  position: relative;

  .title_img {
    width: 24px;
    height: 24px;
    margin-left: 16px;

    img {
      width: 100%;
      height: 100%;
      flex-shrink: 0;
    }
  }

  .title_content {
    width: 100%;
    text-align: center;
    position: absolute;
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    color: #333;
  }
}

.table {
  margin-top: 16px;
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  border: 1px solid #DDDDDD;
  border-bottom: 0; // 去除下边框
  border-radius: 2px;
  max-height: 250px;
  overflow: auto;
  margin: 10px;

  table {
    // border: 1px solid #DDD;
    border-collapse: collapse;


  }

  // color: #333;
  // font-family: Alibaba PuHuiTi;
  // font-size: 14px !important;
  // font-style: normal;
  // font-weight: 400;
  tr {
    height: 32px;

    td {
      border-bottom: 1px solid #DDD;
      padding-left: 12px;
    }
  }
}

// 门店下拉框样式
.title_xia {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;

  div {
    color: #333;
    font-family: Alibaba;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }

}

.fengjiexiao {
  width: 100%;
  border: px2rem(1) dashed #f5f5f5;
  margin-top: px2rem(20);
  margin-bottom: px2rem(20);
}

.yes {
  color: #00bf2a;
}

.reds {
  color: #e30f0f;
}

// 时间选择器
.title_nav {
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  padding-bottom: 6px;
  padding-top: 2px;

  .nav {
    width: 92%;
    display: flex;
    justify-content: space-between;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 12px;
      height: 12px;
    }

    .nav_text {
      color: rgb(102, 102, 102);
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }

    .onep {
      display: flex;
      justify-content: center;

      align-items: center;

      ::v-deep i {
        display: none;
      }

      span {
        color: #333;
        font-family: Alibaba PuHuiTi;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
      }
    }
  }
}


.el-divider--horizontal {
  margin: px2rem(20) 0;
}

// 内容
.tent {
  height: 100%;
  background-color: #f5f5f5;
  padding: 10px;
  padding-top: 0;

  .lbimg {
    display: flex;
    overflow: hidden;

    .lbimg_content {
      width: 100%;
      flex-shrink: 0;
    }

  }

  //logo


  .content_one {
    border-radius: 10px;
    background-color: #ffffff;
    padding: 12px;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    border-top-right-radius: 0;
    border-top-left-radius: 0;

    .ont_content {
      // margin-top: 55px;
      width: 100%;
      height: 128px;
      border-radius: 5px;
      background: #F8F8F8;
      display: flex;
      align-items: center;

      .content_left {
        width: 34%;
        height: 128px;

        .left_content {
          display: flex;
          height: 128px;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }

          div {
            margin-top: 8px;
          }

          .content_jin {
            color: #666;
            font-family: Alibaba PuHuiTi;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }

          .content_qian {
            color: #333;
            font-family: Alibaba;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
          }
        }
      }

      .fengjiexian {
        width: 1px;
        height: 104px;
        background: rgba(221, 221, 221, 0.87);
      }

      .right_content {
        display: flex;
        flex: 1;
        flex-direction: column;

        .right_top {
          display: flex;
          justify-content: space-between;
          margin-left: 12px;
          margin-right: 12px;
          margin-top: 8px;
          margin-bottom: 8px;

          .top_content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 45%;
            height: 40px;

            .text_top {
              color: #666;
              text-align: center;
              font-family: Alibaba PuHuiTi;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
            }

            .text_buttom {
              color: #333;
              text-align: center;
              font-family: Alibaba PuHuiTi;
              font-size: 18px;
              font-style: normal;
              font-weight: 500;
              line-height: 18px;
              margin-top: px2rem(8);
            }
          }
        }
      }
    }
  }


  .content_tow {
    border-radius: px2rem(25);
    margin-top: px2rem(20);
    background-color: #ffffff;

    .fengjiexiao {
      width: 100%;
      border: px2rem(1) dashed #DDDDDD;
      // margin-top: px2rem(12) !important;
      // margin-bottom: px2rem(12) !important;
    }

    .tow_title {
      display: flex;
      align-items: center;
      flex-direction: row;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);

      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: rgb(51, 51, 51);
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

      div {
        color: #333;
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        /* 100% */
      }
    }

    .three_table_content:first-child {
      margin-top: 0px;
    }

    .tow_content {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      padding: 12px;
      position: relative;

      .tow_content_one {
        width: 100%;
        padding-bottom: 12px;

        .tow_one {
          font-size: 14px;
          padding-bottom: 15px;

          .tow_one_top {
            color: #333;

            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
          }

          .tow_one_bouutom {
            margin-top: 12px;
            display: flex;

            .bouutom_one {
              color: #E30F0F;
              display: flex;
              align-items: center;
              font-family: Alibaba;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;

              img {
                width: 12px;
                height: 12px;
              }
            }

            .bouutom_tow {
              color: #999;
              font-family: Alibaba;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              margin-left: 10px;
            }
          }

        }

        .tow_tow {
          // margin-top: 16px;
          border-radius: 5px;
          font-size: 12px;
        }

        .tow_three {
          // width: 100%;
          // margin-top: 8px;

          .tow_three_title {
            color: #333;

            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
          }

          .tow_three_table {
            display: flex;
            flex-direction: column;
          }

          .three_maring {
            margin-top: 0px !important;
          }

          .three_table_content {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .red {
              color: #E30F0F !important;
            }

            .three_table_content_name {
              color: rgb(102, 102, 102);
              font-size: 16px;
              font-weight: 400;
            }


            .three_table_content_price {
              display: flex;
              text-align: right;
              font-style: normal;
              color: rgb(51, 51, 51);
              font-size: 16px;
              font-weight: 500;
              display: flex;
              justify-content: center;
              align-items: center;

              .three_table_content_ifg {
                display: flex;
                justify-content: center;
                align-items: center;
              }

              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
      }

    }
  }

  .content_throw {
    border-radius: px2rem(25);
    margin-top: px2rem(20);
    background-color: #ffffff;

    .throw_nav {
      display: flex;
      justify-content: space-between;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);
    }

    .throw_buttom {
      display: flex;
      justify-content: center;
      color: #999;
      text-align: right;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .button_imgs {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

    }

    .tow_title {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      flex-direction: row;


      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

    }

    .throw_content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding-left: px2rem(20);
      padding-right: px2rem(20);
      margin-bottom: px2rem(20);

      .content_tow {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        // align-items: center;
        width: 40%;
        height: 50px;

        .tow_top {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .tow_img {
            display: flex;
            color: #666666;
            font-size: px2rem(26);

            .img {
              width: 18px;
              height: 18px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 2px;
                background: #FFC300;
              }
            }

            .tow_img_text {
              margin-left: px2rem(10);
              color: #666;
              font-family: Alibaba;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
            }

          }

          .tow_right {
            width: 33px;
            height: 16px;
            color: #666;
            text-align: center;
            font-family: Alibaba PuHuiTi;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            border-radius: 8px;
            background: #F5F5F5;
          }
        }


        .tow_yuan {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          margin-top: px2rem(10);

        }

        .tow_button {
          display: flex;
          margin-top: px2rem(20);

          .button_text {
            font-size: px2rem(20);
            color: #999999;
            margin-right: px2rem(15);
          }
        }
      }
    }

  }


  .content_foue {
    border-radius: px2rem(25);
    margin-top: px2rem(20);
    background-color: #ffffff;

    .throw_nav {
      display: flex;
      justify-content: space-between;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);
    }

    .throw_buttom {
      display: flex;
      justify-content: center;
      color: #999;
      text-align: right;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .button_imgs {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

    }

    .tow_title {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      flex-direction: row;


      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

    }

    .throw_content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding-left: px2rem(20);
      padding-right: px2rem(20);
      margin-bottom: px2rem(20);

      .content_tow {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        // align-items: center;
        width: 40%;
        height: 50px;

        .tow_top {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .tow_img {
            display: flex;
            color: #666666;
            font-size: px2rem(26);

            .img {
              width: 18px;
              height: 18px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 2px;
                background: #FFC300;
              }
            }

            .tow_img_text {
              margin-left: px2rem(10);
              color: #666;
              font-family: Alibaba;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
            }

          }

          .tow_right {
            width: 33px;
            height: 16px;
            color: #666;
            text-align: center;
            font-family: Alibaba PuHuiTi;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            border-radius: 8px;
            background: #F5F5F5;
          }
        }


        .tow_yuan {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          margin-top: px2rem(10);

        }

        .tow_button {
          display: flex;
          margin-top: px2rem(20);

          .button_text {
            font-size: px2rem(20);
            color: #999999;
            margin-right: px2rem(15);
          }
        }
      }
    }

    .tow_content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      // padding-top: px2rem(10);
      // padding-bottom: px2rem(10);
      padding: 12px;
      position: relative;

      .tow_content_tent {
        display: flex;
        width: 40%;
        // height: px2rem(120);
        flex-direction: column;
        justify-content: center;
        background-color: #f8f8f8;
        border-radius: 5px;
        padding: 16px 12px;
        // margin: px2rem(10);
        color: #999;
        font-family: Alibaba;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px;

        img {
          width: 12px;
          height: 12px;
        }

        /* 100% */
        .tent_title {
          display: flex;
          justify-content: space-between;

          .title_left {
            color: #666;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            /* 100% */
          }

          .title_right {
            color: #333;
            text-align: right;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
          }
        }

        .gress {
          margin-top: 16px;
          color: #05AC03;
          font-family: Alibaba;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }

        .gressOne {
          margin-top: 16px;
          color: #666;
          font-family: Alibaba;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px;
          /* 100% */
        }

        .red {
          color: #E30F0F;
          font-family: Alibaba;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          margin-top: 16px;
          margin-bottom: 2px;
        }

        .gresstow {
          margin-top: 16px;
          margin-bottom: 16px;
        }
      }

    }
  }

  .foue_content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: px2rem(150);

    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .conten_one {
      width: 45%;
      margin-right: px2rem(10);
      text-align: center;
      color: #666;
      text-align: center;
      font-family: Alibaba PuHuiTi;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .one_text {
        margin-top: px2rem(12);
        color: #333;
        text-align: center;
        font-family: Alibaba;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;

      }
    }

    .content_title {
      border: px2rem(1) dashed #DDD;
      height: px2rem(24);
      margin-left: px2rem(30);
      margin-right: px2rem(30);
    }
  }

  .content_five {
    border-radius: px2rem(25);
    margin-top: px2rem(20);
    background-color: #ffffff;

    .throw_nav {
      display: flex;
      justify-content: space-between;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);
    }

    .throw_buttom {
      display: flex;
      justify-content: center;
      color: #999;
      text-align: right;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .button_imgs {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

    }

    .tow_title {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      flex-direction: row;


      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

    }

    .fiv_content {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      // width: 100%;
      padding: 12px;
      padding-bottom: 0px;
      padding-top: 0px;

      .fiv {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: self-end;
      }

      .contet_fiv_text {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .fiv_text_left {
          width: 14.667px;
          height: 12.667px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .fiv_text_content {
          width: 100%;
          // margin-left: 8px;
          display: flex;
          flex-direction: column;

          .fiv_top {
            display: flex;
            justify-content: space-between;
            color: #333;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;

            .yess {
              color: #C2986E;
              font-family: Alibaba;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              /* 100% */
            }
          }

          .fiv_boumm {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            color: #333;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
          }
        }


      }

      .fengjiexiao {
        width: 90%;
        border: px2rem(1) dashed #DDDDDD;
        margin-top: 10px;
        margin-bottom: 10px;
        margin-right: 25px;
      }
    }

    .five_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 16px;
      margin-top: 16px;

      .bottom_xia {
        height: 46px;
        width: 85%;
        border-radius: 5px;
        background: #F8F8F8;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 12px;
        margin-right: 12px;
        padding-left: 12px;
        padding-right: 12px;
        color: #333;
        font-family: Alibaba;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;

        /* 100% */
      }
    }
  }

  .content_six {
    border-radius: px2rem(25);
    background-color: #ffffff;
    margin-top: px2rem(20);

    .six_title {
      color: #333;
      font-family: Alibaba PuHuiTi;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      padding: 12px;
      padding-top: 0px;
      margin-bottom: 4px;
      /* 100% */
    }

    .throw_nav {
      display: flex;
      justify-content: space-between;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);
    }

    .throw_buttom {
      display: flex;
      justify-content: center;
      color: #999;
      text-align: right;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .button_imgs {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

    }

    .tow_title {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      flex-direction: row;


      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

    }

    .six {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: calc(100% - 32px);
      padding: 16px;
      padding-top: 0;

      table {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-around;

        .table_tr {
          color: #999;
          font-family: Alibaba;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }

        tr {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 16px;

          td {
            width: 70px;
          }

          .td_one {
            color: #333;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }

          .td_tow {
            color: #333;
            text-align: center;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }

          .td_three {
            color: #333;
            text-align: center;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }

          .td_foue {
            width: 110px;
            color: #333;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px;
          }

          .red {
            color: #E30F0F;
          }
        }
      }
    }

    .fiv_content {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      // width: 100%;
      padding: 12px;
      padding-bottom: 0px;
      padding-top: 0px;

      .fiv {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .contet_fiv_text {
        display: flex;
        justify-content: left;
        width: 100%;

        .fiv_text_left {
          width: 14.667px;
          height: 12.667px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .fiv_text_content {
          width: 100%;
          // margin-left: 8px;
          display: flex;
          flex-direction: column;

          .fiv_top {
            display: flex;
            justify-content: space-between;
            color: #333;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;

            .hu {
              color: #333333 !important;
            }

            .yess {
              color: #E30F0F;
              font-family: Alibaba;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              /* 100% */
            }
          }

          .fiv_boumm {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            color: #333;
            font-family: Alibaba;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
          }
        }


      }

      .fengjiexiao {
        width: 90%;
        border: px2rem(1) dashed #DDDDDD;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-right: 25px;
      }
    }
  }

  .content_server {
    border-radius: px2rem(25);
    margin-top: px2rem(20);
    background-color: #ffffff;

    .throw_nav {
      display: flex;
      justify-content: space-between;
      padding: px2rem(20);
      background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
      border-top-right-radius: px2rem(25);
      border-top-left-radius: px2rem(25);
    }

    .throw_buttom {
      display: flex;
      justify-content: center;
      color: #999;
      text-align: right;
      font-family: Alibaba;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .button_imgs {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

    }

    .tow_title {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      flex-direction: row;


      .title_chu {
        width: 16px;
        height: 16px;
        margin-right: px2rem(10);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title_top {
        display: flex;
        flex: 1;
        justify-content: space-between;

        div {
          color: #333;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;

          /* 100% */

        }

        .top_red {
          color: #E30F0F;
          font-family: Alibaba PuHuiTi;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          /* 100% */
        }
      }

    }

    .server {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: calc(100% - 24px);
      padding: 16px 12px;
      // padding-bottom: 8px;
      // padding: 16px 0;

      .server_title {
        width: 100%;
        text-align: left;
        color: #333;
        font-family: Alibaba;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        /* 100% */
      }

      .server_one {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 16px;

        .one_content {
          width: 49%;
          height: 80px;
          border-radius: 5px;
          background: #F8F8F8;
          // padding-bottom: 10px;

          .one_title {
            margin-top: 16px;
            margin-left: 12px;
            margin-right: 12px;
            display: flex;
            justify-content: space-between;
            color: #666;
            font-family: Alibaba;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;

            /* 100% */
            .title_num {
              color: #333;
              text-align: right;
              font-family: Alibaba;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              display: flex;
              align-items: center;

              img {
                width: 14px;
                height: 14px;
                margin-left: 4px;
              }

              /* 100% */
            }
          }

          .one_price {
            margin-top: 8px;

            text-align: right;
            color: #333;
            text-align: right;
            font-family: Alibaba;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            padding-right: 12px;
            /* 100% */
          }
        }
      }

      .dasiu {
        width: calc(100%);
        padding: 16px 0;
        padding-bottom: 5px;
        // padding: 16px;
      }

      .fiv_content {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        width: calc(100%);
        // padding:16px;
        padding-bottom: 0px;
        padding-top: 0px;
        color: #333 !important;

        .fiv {
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .contet_fiv_text {
          display: flex;
          justify-content: left;
          width: calc(100%);

          .fiv_text_left {
            width: 14.667px;
            height: 12.667px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .fiv_text_content {
            width: 100%;
            display: flex;
            flex-direction: column;

            .fiv_top {
              display: flex;
              justify-content: space-between;
              color: #333;
              font-family: Alibaba;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;

              .yess {
                color: #C2986E;
                font-family: Alibaba;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                /* 100% */
              }
            }

            .fiv_boumm {
              margin-top: 16px;
              display: flex;
              justify-content: space-between;
              color: #333;
              font-family: Alibaba;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
            }
          }


        }

        .fengjiexiao {
          width: 100%;
          border: px2rem(1) dashed #DDDDDD;
          margin-top: px2rem(20);
          margin-bottom: px2rem(20);
          // margin-right: 25px;
        }
      }
    }
  }


}
</style>
